var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginIllustration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 752 585",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12 {\n        fill: none;\n      }\n\n      .cls-2 {\n        stroke-width: 3px;\n      }\n\n      .cls-2, .cls-3, .cls-6, .cls-7, .cls-13, .cls-14, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2, .cls-7, .cls-8, .cls-12 {\n        stroke: #9ad0ff;\n      }\n\n      .cls-15 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-3 {\n        stroke: #8ec4ff;\n        stroke-width: 1.08px;\n      }\n\n      .cls-16 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-17 {\n        fill: #005eff;\n      }\n\n      .cls-18, .cls-13, .cls-19, .cls-20 {\n        fill: #fff;\n      }\n\n      .cls-21 {\n        fill: #f0f1f4;\n      }\n\n      .cls-22 {\n        fill: #e2e4e9;\n      }\n\n      .cls-23 {\n        fill: #e4f2ff;\n      }\n\n      .cls-24 {\n        fill: #80858d;\n      }\n\n      .cls-25 {\n        fill: #009c99;\n      }\n\n      .cls-26 {\n        fill: #8ec4ff;\n      }\n\n      .cls-27 {\n        fill: #babfc3;\n      }\n\n      .cls-28, .cls-14 {\n        fill: #cdeaff;\n      }\n\n      .cls-29, .cls-30 {\n        fill: #dde1e5;\n      }\n\n      .cls-31 {\n        fill: #d5d9dd;\n      }\n\n      .cls-32 {\n        fill: #d5ebff;\n      }\n\n      .cls-33 {\n        fill: #20d5d2;\n      }\n\n      .cls-34 {\n        fill: #22272a;\n      }\n\n      .cls-35 {\n        fill: #0bbcb9;\n      }\n\n      .cls-36 {\n        fill: #9ba1a7;\n      }\n\n      .cls-37 {\n        fill: #43e0e0;\n      }\n\n      .cls-38 {\n        fill: #6db3ff;\n      }\n\n      .cls-39, .cls-40, .cls-41 {\n        fill: #9ad0ff;\n      }\n\n      .cls-42 {\n        fill: #353a3d;\n      }\n\n      .cls-43 {\n        fill: #338dff;\n      }\n\n      .cls-4 {\n        stroke: #d5ebff;\n      }\n\n      .cls-4, .cls-5 {\n        stroke-miterlimit: 6;\n      }\n\n      .cls-4, .cls-5, .cls-7, .cls-13 {\n        stroke-linecap: round;\n      }\n\n      .cls-4, .cls-8, .cls-9 {\n        stroke-width: 2px;\n      }\n\n      .cls-44 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-44, .cls-45, .cls-46, .cls-47, .cls-48 {\n        opacity: .37;\n      }\n\n      .cls-44, .cls-45, .cls-46, .cls-47, .cls-48, .cls-49 {\n        mix-blend-mode: screen;\n      }\n\n      .cls-45 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-46 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-47 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-5, .cls-14 {\n        stroke: #005eff;\n      }\n\n      .cls-6 {\n        stroke-width: .72px;\n      }\n\n      .cls-6, .cls-9 {\n        stroke: #fff;\n      }\n\n      .cls-13 {\n        stroke: #d5d9dd;\n      }\n\n      .cls-50 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-51 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-48 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-52 {\n        fill: #0a9f9b;\n        opacity: .4;\n      }\n\n      .cls-52, .cls-53 {\n        mix-blend-mode: multiply;\n      }\n\n      .cls-49 {\n        fill: url(#linear-gradient-13);\n        opacity: .2;\n      }\n\n      .cls-40 {\n        opacity: .32;\n      }\n\n      .cls-54 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-55 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-56 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-57 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-10 {\n        stroke: #b4dbff;\n      }\n\n      .cls-11 {\n        stroke: #6db3ff;\n      }\n\n      .cls-58, .cls-20 {\n        opacity: .6;\n      }\n\n      .cls-59, .cls-60 {\n        opacity: .5;\n      }\n\n      .cls-61 {\n        fill: url(#linear-gradient-14);\n        opacity: .81;\n      }\n\n      .cls-41 {\n        fill-rule: evenodd;\n      }\n\n      .cls-62 {\n        fill: url(#linear-gradient-12);\n      }\n\n      .cls-63 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-64 {\n        isolation: isolate;\n      }\n\n      .cls-19 {\n        font-family: MyriadPro-Regular, 'Myriad Pro';\n        font-size: 12px;\n      }\n\n      .cls-53 {\n        opacity: .46;\n      }\n\n      .cls-60 {\n        fill: #0052d7;\n      }\n\n      .cls-30 {\n        opacity: .38;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 165.79,
    cy: 188.65,
    r: 70.85
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 256.5,
    cy: 118.5,
    r: 61
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 222.97,
    y1: 111.08,
    x2: 291,
    y2: 111.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2f99ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#2ca1e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#27b8df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#23c8d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#20d1d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20d5d2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 222.97,
    y1: 111.04,
    x2: 291,
    y2: 111.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#20d5d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#23c5db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#2e9ef4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#338dff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    y1: 129.08,
    y2: 129.08,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    y1: 129.04,
    y2: 129.04,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    y1: 147.08,
    y2: 147.08,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    y1: 147.04,
    y2: 147.04,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    y1: 165.08,
    y2: 165.08,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    y1: 165.04,
    y2: 165.04,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    y1: 183.08,
    y2: 183.08,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    y1: 183.04,
    y2: 183.04,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 509,
    cy: 183,
    r: 100.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 606,
    y1: 183.5,
    x2: 612.76,
    y2: 183.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d5d9dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#d2d6da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#caced2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#bbc0c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#babfc3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 648.73,
    y1: 212.96,
    x2: 724.85,
    y2: 136.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#338dff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#3190fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#2aaeea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#24c3dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#21d0d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20d5d2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 650.98,
    y1: 215.21,
    x2: 722.6,
    y2: 143.6,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 266.03,
    y1: 346.73,
    x2: 474.21,
    y2: 194.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8ec4ff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#8fc4ff",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#93c6ff",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#9bcaff",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#a5d0ff",
    stopOpacity: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#b2d7ff",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#c3dfff",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#d6e9ff",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#ecf5ff",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mesh"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M492.44,80.54h0c-.3-.46-.17-1.08,.29-1.39h0c.47-.3,1.08-.17,1.39,.3h0c.3,.46,.17,1.08-.29,1.38h0c-.17,.11-.36,.16-.55,.16h0c-.33,0-.65-.16-.84-.45Zm-3.94-5.71h0c-.32-.44-.22-1.07,.22-1.4h0c.45-.32,1.08-.23,1.4,.22h0c.33,.45,.23,1.07-.22,1.4h0c-.18,.13-.38,.19-.59,.19h0c-.3,0-.61-.14-.8-.41Zm-4.25-5.49c-.35-.43-.29-1.06,.14-1.41h0c.43-.35,1.06-.28,1.41,.15h0c.35,.42,.29,1.05-.14,1.4h0c-.19,.15-.41,.23-.63,.23h0c-.29,0-.58-.13-.78-.37Zm-4.53-5.26h0c-.37-.41-.34-1.04,.07-1.41h0c.4-.37,1.04-.34,1.41,.07h0c.37,.41,.34,1.04-.07,1.41h0c-.19,.17-.43,.26-.67,.26h0c-.27,0-.54-.11-.74-.33Zm-4.81-5.01c-.39-.39-.39-1.02-.01-1.42h0c.4-.39,1.03-.39,1.42,0h0c.39,.39,.4,1.02,.01,1.41h0c-.2,.2-.46,.3-.71,.3h0c-.26,0-.51-.1-.71-.29Zm-183.24-.99c-.39-.4-.37-1.04,.02-1.42h0c.4-.39,1.03-.37,1.42,.02h0c.38,.4,.37,1.03-.03,1.42h0c-.19,.18-.44,.28-.69,.28h0c-.26,0-.53-.1-.72-.3Zm178.18-3.76h0c-.41-.37-.45-1-.09-1.41h0c.37-.41,1.01-.45,1.42-.09h0c.41,.37,.45,1,.08,1.41h0c-.2,.23-.47,.34-.75,.34h0c-.24,0-.47-.08-.66-.25Zm-173.07-1.02c-.36-.41-.31-1.05,.1-1.41h0c.42-.36,1.05-.32,1.41,.1h0c.37,.41,.32,1.05-.09,1.41h0c-.19,.17-.43,.25-.66,.25h0c-.28,0-.56-.12-.76-.35Zm167.76-3.46h0c-.43-.34-.5-.97-.15-1.4h0c.34-.44,.97-.51,1.4-.16h0c.43,.34,.51,.97,.16,1.4h0c-.2,.25-.49,.38-.78,.38h0c-.22,0-.44-.07-.62-.22Zm-162.39-1.03c-.34-.43-.26-1.06,.17-1.4h0c.44-.34,1.07-.26,1.41,.17h0c.33,.44,.26,1.06-.18,1.4h0c-.18,.14-.4,.21-.61,.21h0c-.3,0-.59-.13-.79-.38Zm156.84-3.16h0c-.45-.32-.55-.94-.23-1.39h0c.32-.45,.95-.56,1.39-.24h0c.45,.32,.56,.95,.24,1.4h0c-.2,.27-.51,.42-.82,.42h0c-.2,0-.4-.06-.58-.19Zm-151.25-1.04c-.31-.45-.21-1.07,.25-1.39h0c.45-.32,1.07-.21,1.39,.25h0c.32,.45,.21,1.07-.24,1.39h0c-.17,.12-.37,.18-.57,.18h0c-.31,0-.62-.15-.82-.43Zm145.49-2.84c-.46-.3-.6-.92-.3-1.39h0c.29-.46,.91-.6,1.37-.3h0c.47,.29,.61,.91,.31,1.38h0c-.19,.3-.51,.46-.84,.46h0c-.19,0-.37-.05-.54-.15Zm-139.68-1.05c-.29-.47-.15-1.09,.32-1.38h0c.47-.29,1.08-.15,1.38,.32h0c.29,.47,.14,1.08-.33,1.38h0c-.16,.1-.34,.15-.52,.15h0c-.34,0-.66-.17-.85-.47Zm133.72-2.53c-.48-.27-.65-.88-.38-1.36h0c.27-.48,.88-.65,1.36-.38h0c.48,.27,.65,.88,.38,1.36h0c-.18,.33-.52,.51-.87,.51h0c-.17,0-.33-.04-.49-.13Zm-127.72-1.05c-.26-.48-.09-1.09,.4-1.36h0c.48-.27,1.09-.09,1.35,.39h0c.27,.49,.09,1.1-.39,1.36h0c-.15,.09-.32,.13-.48,.13h0c-.35,0-.7-.19-.88-.52Zm121.57-2.2c-.49-.25-.69-.85-.45-1.34h0c.25-.5,.85-.7,1.34-.45h0c.5,.24,.7,.84,.45,1.34h0c-.17,.35-.52,.55-.89,.55h0c-.15,0-.3-.03-.45-.1Zm-115.38-1.05c-.24-.5-.04-1.1,.46-1.34h0c.5-.24,1.1-.03,1.34,.47h0c.24,.5,.03,1.09-.47,1.33h0c-.14,.07-.29,.1-.43,.1h0c-.37,0-.73-.2-.9-.56Zm109.07-1.87c-.5-.22-.74-.81-.52-1.31h0c.22-.51,.81-.75,1.31-.53h0c.51,.22,.74,.81,.53,1.31h0c-.17,.38-.54,.61-.92,.61h0c-.13,0-.27-.03-.4-.08Zm-102.73-1.05c-.21-.51,.03-1.09,.54-1.31h0c.51-.21,1.1,.03,1.31,.54h0c.21,.51-.03,1.09-.54,1.31h0c-.12,.05-.26,.08-.38,.08h0c-.4,0-.77-.23-.93-.62Zm6.49-2.57c-.18-.52,.09-1.09,.61-1.28h0c.52-.18,1.09,.09,1.28,.61h0c.19,.52-.09,1.09-.61,1.28h0c-.11,.04-.22,.06-.33,.06h0c-.41,0-.8-.26-.95-.67Zm6.64-2.22c-.16-.53,.15-1.08,.67-1.24h0c.52-.16,1.08,.14,1.24,.67h0c.16,.53-.15,1.09-.68,1.24h0c-.09,.03-.19,.05-.28,.05h0c-.43,0-.83-.28-.96-.72Zm69.86-.82c-.54-.13-.86-.68-.73-1.21h0c.13-.54,.67-.86,1.21-.73h0c.54,.13,.86,.68,.73,1.21h0c-.12,.46-.52,.76-.97,.76h0c-.08,0-.16,0-.24-.03Zm-63.12-1.04c-.12-.54,.21-1.08,.75-1.21h0c.53-.12,1.07,.21,1.2,.75h0c.13,.53-.2,1.07-.74,1.2h0c-.08,.02-.15,.03-.23,.03h0c-.45,0-.86-.31-.98-.77Zm56.34-.46c-.54-.1-.9-.63-.79-1.17h0c.1-.54,.62-.9,1.17-.79h0c.54,.1,.89,.63,.79,1.17h0c-.09,.48-.51,.81-.98,.81h0c-.06,0-.13,0-.19-.02Zm-49.5-1.04c-.1-.54,.26-1.06,.81-1.16h0c.55-.1,1.07,.26,1.17,.8h0c.1,.54-.26,1.07-.8,1.17h0c-.06,0-.12,.02-.18,.02h0c-.47,0-.89-.34-.98-.83Zm42.65-.09h0c-.55-.08-.93-.58-.86-1.13h0c.08-.55,.58-.93,1.13-.85h0c.55,.07,.93,.58,.86,1.12h0c-.07,.51-.51,.87-1,.87h0s-.09,0-.13,0Zm-35.74-1.03c-.07-.55,.31-1.05,.86-1.12h0c.55-.07,1.05,.32,1.12,.86h0c.07,.55-.32,1.05-.87,1.12h0s-.09,0-.13,0h0c-.5,0-.93-.37-.99-.87Zm28.84,.26c-.55-.04-.96-.53-.92-1.08h0c.05-.55,.53-.96,1.08-.91h0c.56,.04,.96,.53,.92,1.08h0c-.05,.52-.48,.92-1,.92h0s-.06,0-.08,0Zm-21.89-1.02c-.04-.55,.37-1.03,.92-1.07h0c.55-.04,1.03,.37,1.08,.92h0c.04,.55-.38,1.03-.93,1.07h0s-.05,.01-.07,.01h0c-.52,0-.96-.4-1-.93Zm14.95,.63c-.55-.02-.98-.48-.96-1.03h0c0-.56,.47-.99,1.03-.97h0c.55,.01,.98,.47,.96,1.03h0c0,.54-.46,.97-1,.97h-.03Zm-6.94-.04c-.55,.01-1.01-.42-1.02-.98h0c0-.55,.42-1.01,.98-1.02h0c.55,0,1.01,.43,1.02,.98h0c0,.55-.43,1.01-.98,1.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M682.65,136.9c-.24-.5-.03-1.1,.47-1.33h0c.5-.24,1.1-.03,1.33,.47h0c.24,.5,.03,1.1-.47,1.34h0c-.14,.06-.29,.09-.43,.09h0c-.37,0-.73-.21-.9-.57Zm-3.19-6.14h0c-.27-.48-.1-1.09,.38-1.36h0c.48-.28,1.09-.11,1.36,.38h0c.27,.47,.1,1.08-.38,1.36h0c-.15,.08-.32,.13-.49,.13h0c-.35,0-.68-.19-.87-.51Zm-3.61-5.91c-.31-.46-.18-1.08,.28-1.38h0c.46-.3,1.08-.18,1.38,.28h0c.31,.46,.18,1.08-.28,1.39h0c-.17,.11-.36,.16-.55,.16h0c-.32,0-.64-.15-.83-.45Zm-4.03-5.63c-.34-.43-.26-1.06,.18-1.4h0c.44-.34,1.07-.26,1.41,.18h0c.33,.44,.25,1.07-.19,1.41h0c-.18,.13-.39,.2-.61,.2h0c-.3,0-.59-.13-.79-.39Zm-4.41-5.33c-.37-.42-.33-1.05,.08-1.42h0c.41-.36,1.04-.32,1.41,.09h0c.37,.41,.33,1.04-.08,1.41h0c-.19,.17-.43,.25-.67,.25h0c-.27,0-.55-.11-.74-.33Zm-4.78-5.02c-.4-.38-.41-1.01-.02-1.41h0c.39-.39,1.02-.4,1.41-.02h0c.4,.39,.41,1.02,.02,1.42h0c-.19,.2-.45,.3-.71,.3h0c-.26,0-.51-.1-.7-.29Zm-5.13-4.66c-.42-.35-.47-.99-.11-1.41h0c.35-.42,.99-.47,1.4-.11h0c.43,.35,.48,.99,.12,1.41h0c-.2,.23-.48,.35-.76,.35h0c-.23,0-.46-.08-.65-.24Zm-5.44-4.29c-.44-.32-.54-.95-.21-1.4h0c.32-.44,.95-.54,1.39-.21h0c.45,.32,.55,.95,.22,1.4h0c-.2,.26-.5,.41-.81,.41h0c-.2,0-.41-.07-.59-.2Zm-5.73-3.89c-.47-.3-.61-.91-.31-1.38h0c.29-.47,.91-.61,1.38-.31h0c.46,.29,.6,.91,.31,1.37h0c-.19,.31-.52,.47-.85,.47h0c-.18,0-.36-.05-.53-.15Zm-5.99-3.48c-.49-.26-.67-.87-.41-1.35h0c.26-.49,.86-.67,1.35-.42h0c.49,.26,.67,.87,.41,1.36h0c-.18,.33-.53,.53-.88,.53h0c-.16,0-.32-.04-.47-.12Zm-6.23-3.04c-.51-.23-.73-.82-.51-1.32h0c.23-.51,.82-.74,1.32-.51h0c.51,.22,.73,.81,.51,1.32h0c-.17,.37-.53,.59-.91,.59h0c-.14,0-.28-.03-.41-.08Zm-75.54-2.63c-.2-.51,.06-1.09,.57-1.29h0c.52-.2,1.1,.06,1.29,.58h0c.2,.52-.06,1.09-.58,1.29h0c-.11,.04-.24,.06-.35,.06h0c-.41,0-.78-.24-.93-.64Zm69.11,.03c-.52-.18-.79-.75-.6-1.27h0c.18-.52,.76-.79,1.28-.61h0c.52,.19,.79,.77,.6,1.29h0c-.15,.4-.53,.65-.94,.65h0c-.11,0-.23,0-.34-.06Zm-62.51-2.35c-.16-.53,.14-1.08,.67-1.24h0c.53-.16,1.09,.14,1.25,.67h0c.16,.52-.14,1.08-.67,1.24h0c-.09,.03-.19,.04-.28,.04h0c-.44,0-.83-.28-.96-.71Zm55.92,.23c-.54-.15-.85-.7-.69-1.23h0c.15-.53,.7-.84,1.23-.69h0c.53,.15,.84,.7,.69,1.23h0c-.12,.45-.53,.73-.96,.73h0c-.09,0-.18-.01-.27-.04Zm-49.17-2.07c-.13-.54,.21-1.07,.75-1.19h0c.54-.12,1.08,.22,1.2,.76h0c.12,.53-.22,1.07-.76,1.19h0c-.07,.02-.15,.02-.22,.02h0c-.46,0-.87-.31-.97-.78Zm42.44,.43h0c-.54-.11-.89-.64-.78-1.18h0c.12-.54,.64-.89,1.18-.78h0c.55,.11,.89,.64,.78,1.18h0c-.1,.48-.51,.8-.98,.8h0c-.06,0-.13,0-.2-.02Zm-35.58-1.78c-.08-.55,.3-1.06,.84-1.14h0c.55-.08,1.06,.3,1.14,.84h0c.08,.55-.3,1.06-.84,1.14h0s-.1,0-.15,0h0c-.49,0-.91-.36-.99-.85Zm28.75,.62h0c-.55-.08-.93-.58-.85-1.12h0c.07-.55,.57-.94,1.12-.86h0c.55,.07,.93,.57,.86,1.12h0c-.07,.5-.5,.87-.99,.87h0s-.09,0-.14-.01Zm-21.81-1.48c-.04-.55,.37-1.03,.92-1.08h0c.55-.04,1.03,.37,1.08,.92h0c.04,.55-.37,1.03-.92,1.08h-.08c-.52,0-.96-.4-1-.92Zm14.92,.81c-.55-.04-.97-.51-.94-1.06h0c.04-.55,.51-.97,1.06-.94h0c.55,.03,.98,.51,.94,1.06h0c-.03,.53-.47,.94-1,.94h-.06Zm-7.93-1.18c0-.56,.44-1.01,.99-1.01h0c.55,0,1,.44,1.01,.99h0c0,.55-.44,1-.99,1.01h0c-.55,0-1-.44-1-.99Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M215.22,359.8h0c-.48-.27-.65-.88-.38-1.36h0c.27-.48,.89-.65,1.37-.38h0c.48,.28,.65,.89,.38,1.37h0c-.18,.32-.52,.5-.87,.5h0c-.17,0-.34-.04-.49-.13Zm-6.01-3.62h0c-.46-.3-.6-.92-.3-1.38h0c.3-.47,.92-.6,1.38-.3h0c.47,.29,.6,.91,.3,1.38h0c-.19,.29-.51,.46-.84,.46h0c-.18,0-.37-.05-.54-.16Zm-5.8-3.93c-.45-.33-.56-.95-.23-1.4h0c.32-.45,.94-.55,1.39-.23h0c.45,.32,.55,.95,.23,1.4h0c-.19,.27-.5,.41-.81,.41h0c-.2,0-.41-.06-.58-.18Zm-5.59-4.24c-.43-.34-.5-.97-.16-1.4h0c.35-.44,.98-.51,1.41-.16h0c.43,.34,.5,.97,.15,1.41h0c-.2,.24-.49,.37-.78,.37h0c-.22,0-.44-.07-.62-.22Zm-5.36-4.52c-.41-.37-.45-1-.08-1.42h0c.37-.41,1-.44,1.41-.08h0c.41,.37,.45,1,.08,1.42h0c-.2,.22-.47,.33-.75,.33h0c-.23,0-.47-.08-.66-.25Zm-5.11-4.81c-.4-.39-.4-1.02,0-1.41h0c.39-.4,1.02-.4,1.42,0h0c.39,.39,.39,1.02,0,1.41h0c-.19,.2-.45,.3-.7,.3h0c-.26,0-.52-.1-.71-.29Zm-13.7-15.93c-.33-.45-.23-1.08,.22-1.4h0c.44-.33,1.07-.23,1.39,.22h0c.33,.44,.23,1.07-.22,1.39h0c-.17,.13-.38,.19-.59,.19h0c-.3,0-.61-.14-.8-.4Zm-3.98-5.78c-.3-.46-.17-1.08,.29-1.39h0c.47-.29,1.09-.17,1.39,.3h0c.31,.46,.17,1.08-.29,1.38h0c-.17,.11-.36,.16-.54,.16h0c-.33,0-.65-.16-.84-.45Zm-3.66-5.98h0c-.28-.48-.11-1.09,.36-1.36h0c.48-.28,1.09-.12,1.37,.36h0c.27,.48,.11,1.09-.37,1.37h0c-.15,.09-.33,.13-.5,.13h0c-.34,0-.68-.18-.86-.5Zm-3.34-6.16c-.25-.5-.06-1.1,.44-1.35h0c.49-.25,1.09-.05,1.34,.44h0c.25,.49,.05,1.09-.44,1.34h0c-.14,.08-.3,.11-.45,.11h0c-.36,0-.71-.2-.89-.54Zm-3.01-6.34h0c-.23-.51,0-1.1,.51-1.32h0c.5-.22,1.09,0,1.31,.51h0c.23,.51,0,1.1-.51,1.32h0c-.13,.06-.26,.08-.4,.08h0c-.38,0-.75-.22-.92-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M157.93,292.62c-.27,0-.52-.11-.71-.3s-.29-.44-.29-.7,.1-.52,.29-.71c.38-.38,1.04-.38,1.41,0,.19,.19,.3,.44,.3,.71s-.11,.51-.3,.7-.44,.3-.7,.3Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M516.33,334.46c-.55-.02-.99-.48-.97-1.04h0c.02-.55,.48-.98,1.04-.96h0c.56,.02,.99,.48,.97,1.03h0c-.02,.54-.46,.97-1,.97h-.03Zm6.03-1.02c-.03-.56,.39-1.03,.94-1.06h0c.55-.03,1.03,.4,1.06,.95h0c.03,.55-.4,1.02-.95,1.05h-.05c-.53,0-.97-.41-1-.94Zm-13.09,.47h0c-.55-.07-.94-.56-.88-1.11h0c.07-.55,.57-.94,1.12-.88h0c.55,.07,.94,.57,.87,1.12h0c-.06,.51-.49,.88-.99,.88h0s-.08,0-.12,0Zm20.06-1.08c-.08-.54,.3-1.05,.85-1.13h0c.54-.08,1.05,.3,1.13,.85h0c.08,.54-.3,1.05-.85,1.13h0s-.1,0-.15,0h0c-.48,0-.91-.36-.98-.86Zm-27.05-.09c-.54-.11-.88-.65-.77-1.19h0c.12-.54,.65-.88,1.19-.77h0c.54,.12,.88,.65,.77,1.19h0c-.1,.47-.52,.79-.98,.79h0c-.07,0-.14,0-.21-.02Zm33.94-1.13c-.13-.53,.2-1.07,.74-1.2h0c.54-.13,1.08,.2,1.2,.74h0c.13,.54-.2,1.08-.74,1.21h0c-.08,.01-.15,.02-.23,.02h0c-.45,0-.86-.31-.97-.77Zm-40.79-.66c-.53-.17-.83-.73-.66-1.26h0c.16-.52,.72-.82,1.25-.65h0c.53,.16,.82,.72,.66,1.25h0c-.13,.43-.53,.7-.96,.7h0c-.1,0-.2,0-.29-.04Zm-6.67-2.41h0c-.51-.2-.76-.79-.55-1.3h0c.21-.51,.8-.75,1.31-.54h0c.51,.21,.75,.79,.54,1.3h0c-.16,.39-.53,.62-.92,.62h0c-.13,0-.26-.02-.38-.08Zm67.08-4.2c-.27-.48-.09-1.09,.4-1.35h0c.48-.27,1.09-.09,1.36,.39h0c.26,.49,.08,1.09-.4,1.36h0c-.15,.08-.32,.12-.48,.12h0c-.35,0-.7-.18-.88-.52Zm6.02-3.56c-.3-.45-.18-1.07,.28-1.38h0c.45-.31,1.08-.19,1.38,.27h0c.31,.46,.19,1.08-.27,1.39h0c-.17,.11-.36,.17-.56,.17h0c-.32,0-.63-.16-.83-.45Zm5.68-4.08c-.34-.43-.27-1.06,.15-1.4h0c.43-.35,1.06-.28,1.41,.14h0c.35,.43,.28,1.06-.15,1.41h0c-.18,.15-.4,.23-.63,.23h0c-.29,0-.58-.13-.78-.38Zm5.31-4.57c-.39-.39-.38-1.03,.02-1.41h0c.39-.38,1.03-.37,1.41,.02h0c.39,.4,.37,1.03-.02,1.42h0c-.2,.18-.45,.28-.7,.28h0c-.26,0-.52-.1-.71-.31Zm4.87-5.02c-.42-.36-.47-.99-.1-1.41h0c.36-.41,.99-.46,1.41-.1h0c.41,.36,.46,1,.1,1.41h0c-.2,.23-.48,.35-.76,.35h0c-.23,0-.46-.08-.65-.25Zm4.41-5.43c-.45-.32-.55-.95-.23-1.4h0c.33-.44,.95-.54,1.4-.22h0c.45,.32,.55,.95,.22,1.39h0c-.19,.27-.5,.42-.81,.42h0c-.2,0-.4-.06-.58-.19Zm3.91-5.8c-.48-.29-.63-.9-.35-1.37h0c.28-.48,.9-.64,1.37-.35h0c.48,.28,.63,.89,.35,1.37h0c-.19,.31-.52,.49-.86,.49h0c-.18,0-.35-.05-.51-.14Zm3.38-6.13c-.5-.24-.71-.84-.47-1.34h0c.24-.49,.83-.7,1.33-.47h0c.5,.24,.71,.84,.47,1.34h0c-.17,.36-.53,.57-.9,.57h0c-.15,0-.29-.03-.43-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M345.4,197.87c-.31-.46-.19-1.08,.27-1.39h0c.46-.31,1.08-.19,1.39,.27h0c.31,.46,.18,1.08-.28,1.39h0c-.17,.11-.36,.17-.55,.17h0c-.32,0-.64-.16-.83-.44Zm-4.1-5.56c-.35-.43-.29-1.06,.14-1.41h0c.43-.35,1.06-.28,1.41,.15h0c.35,.43,.28,1.06-.15,1.41h0c-.18,.15-.4,.22-.62,.22h0c-.3,0-.59-.13-.78-.37Zm-4.58-5.18c-.38-.39-.37-1.03,.02-1.41h0c.4-.38,1.03-.37,1.42,.02h0c.38,.4,.37,1.03-.03,1.42h0c-.19,.18-.44,.28-.69,.28h0c-.26,0-.53-.1-.72-.31Zm-5.02-4.75h0c-.42-.36-.46-.99-.1-1.41h0c.36-.41,.99-.46,1.41-.1h0c.42,.36,.46,1,.1,1.41h0c-.2,.23-.47,.35-.75,.35h0c-.24,0-.47-.08-.66-.25Zm-5.41-4.28c-.45-.33-.56-.95-.23-1.4h0c.32-.44,.95-.55,1.39-.22h0c.45,.32,.55,.94,.23,1.39h0c-.2,.27-.5,.42-.81,.42h0c-.21,0-.41-.06-.58-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M427.16,92.09c-.31-.46-.19-1.08,.27-1.39h0c.46-.31,1.08-.19,1.39,.27h0c.31,.46,.19,1.08-.27,1.39h0c-.17,.11-.37,.17-.56,.17h0c-.32,0-.64-.16-.83-.44Zm-4.05-5.63h0c-.33-.43-.25-1.06,.18-1.4h0c.44-.34,1.07-.26,1.41,.18h0c.33,.44,.25,1.06-.18,1.4h0c-.18,.14-.4,.21-.61,.21h0c-.3,0-.6-.13-.79-.39Zm-4.43-5.32c-.37-.41-.34-1.05,.07-1.41h0c.42-.37,1.05-.34,1.42,.07h0c.36,.42,.33,1.05-.08,1.41h0c-.19,.18-.43,.26-.67,.26h0c-.27,0-.55-.11-.74-.33Zm-4.79-5.01c-.4-.39-.41-1.02-.02-1.42h0c.38-.39,1.02-.4,1.41,0h0c.4,.38,.41,1.01,.02,1.41h0c-.19,.2-.45,.3-.71,.3h0c-.26,0-.51-.09-.7-.28Zm-5.13-4.66h0c-.42-.36-.47-.99-.12-1.41h0c.36-.42,.99-.47,1.41-.12h0c.42,.36,.48,.99,.12,1.41h0c-.2,.24-.48,.36-.77,.36h0c-.22,0-.45-.08-.64-.24Zm-5.44-4.29c-.44-.32-.54-.95-.21-1.39h0c.32-.45,.95-.55,1.4-.22h0c.44,.33,.54,.95,.21,1.4h0c-.2,.26-.5,.41-.81,.41h0c-.2,0-.41-.07-.59-.2Zm-5.72-3.89h0c-.47-.3-.61-.92-.31-1.38h0c.29-.47,.91-.61,1.37-.31h0c.47,.29,.61,.91,.32,1.38h0c-.19,.3-.52,.46-.85,.46h0c-.18,0-.37-.05-.53-.15Zm-5.99-3.49h0c-.48-.26-.67-.86-.41-1.35h0c.26-.49,.87-.67,1.36-.41h0c.48,.26,.67,.87,.41,1.35h0c-.19,.34-.53,.53-.89,.53h0c-.16,0-.32-.04-.47-.12Zm-94.57-.89c-.26-.49-.07-1.1,.42-1.35h0c.49-.26,1.09-.07,1.35,.42h0c.26,.48,.07,1.09-.42,1.35h0c-.15,.08-.31,.11-.47,.11h0c-.36,0-.7-.19-.88-.53Zm88.36-2.16c-.51-.23-.73-.82-.51-1.33h0c.23-.5,.82-.72,1.33-.5h0c.5,.23,.73,.82,.5,1.32h0c-.17,.37-.53,.59-.91,.59h0c-.14,0-.28-.03-.41-.08Zm-82.08-.94c-.23-.51,0-1.1,.51-1.32h0c.5-.22,1.1,.01,1.32,.51h0c.22,.5,0,1.09-.52,1.32h0c-.13,.06-.26,.08-.4,.08h0c-.38,0-.75-.22-.91-.59Zm75.66-1.68c-.51-.19-.78-.77-.59-1.29h0c.19-.52,.77-.78,1.29-.59h0c.51,.19,.78,.77,.59,1.28h0c-.15,.41-.53,.66-.94,.66h0c-.11,0-.23-.02-.35-.06Zm-69.19-.98c-.18-.52,.09-1.09,.61-1.28h0c.52-.18,1.09,.09,1.28,.61h0c.18,.52-.09,1.09-.61,1.28h0c-.11,.04-.22,.05-.33,.05h0c-.41,0-.8-.25-.95-.66Zm62.61-1.19c-.53-.16-.83-.71-.68-1.24h0c.16-.53,.71-.84,1.24-.68h0c.53,.16,.84,.71,.68,1.24h0c-.12,.44-.52,.72-.96,.72h0c-.09,0-.18-.01-.28-.04Zm-55.96-1c-.15-.53,.16-1.08,.69-1.23h0c.54-.15,1.09,.16,1.24,.69h0c.15,.53-.16,1.08-.69,1.23h0c-.09,.03-.19,.04-.28,.04h0c-.43,0-.83-.29-.96-.73Zm49.25-.7c-.54-.12-.88-.65-.76-1.19h0c.11-.54,.64-.89,1.18-.77h0c.54,.12,.89,.65,.77,1.19h0c-.1,.47-.52,.79-.98,.79h0c-.07,0-.14,0-.21-.02Zm-42.46-1.02c-.11-.54,.23-1.07,.77-1.18h0c.54-.11,1.07,.23,1.19,.77h0c.11,.54-.24,1.07-.78,1.19h0c-.07,0-.14,.02-.21,.02h0c-.46,0-.88-.33-.97-.8Zm35.64-.22c-.54-.08-.92-.59-.85-1.14h0c.09-.54,.59-.92,1.14-.84h0c.55,.08,.92,.59,.84,1.13h0c-.07,.5-.49,.86-.98,.86h0s-.1,0-.15,0Zm-28.75-1.02c-.08-.55,.31-1.05,.85-1.13h0c.55-.07,1.05,.31,1.13,.86h0c.07,.55-.32,1.05-.86,1.12h0c-.05,0-.09,0-.14,0h0c-.49,0-.92-.36-.98-.86Zm21.86,.26h.01c-.55-.04-.97-.52-.93-1.08h0c.04-.55,.52-.96,1.08-.92h0c.55,.05,.96,.53,.92,1.08h0c-.04,.52-.48,.92-1,.92h-.08Zm-14.91-1.02c-.03-.55,.39-1.03,.94-1.06h0c.55-.04,1.02,.38,1.06,.93h0c.04,.55-.38,1.03-.94,1.07h-.06c-.52,0-.96-.41-1-.94Zm7.99,.74c-.55,0-1-.46-.99-1.01h0c0-.55,.45-1,1-1h0c.55,0,1,.46,1,1.01h0c0,.55-.45,1-1,1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M54.96,264.01h0c-.49-.27-.66-.88-.39-1.36h0c.27-.48,.88-.65,1.36-.39h0c.48,.27,.66,.88,.39,1.36h0c-.19,.33-.53,.52-.88,.52h0c-.17,0-.33-.04-.48-.13Zm-5.98-3.9c-.44-.33-.53-.95-.19-1.4h0c.33-.44,.96-.52,1.4-.19h0c.44,.33,.52,.96,.19,1.4h0c-.19,.26-.49,.4-.8,.4h0c-.21,0-.42-.07-.6-.21Zm-5.38-4.68c-.39-.39-.39-1.02,0-1.41h0c.39-.39,1.02-.39,1.42,0h0c.39,.39,.39,1.02,0,1.41h0c-.2,.2-.46,.3-.71,.3h0c-.26,0-.51-.1-.71-.3Zm-4.68-5.37c-.34-.44-.25-1.07,.19-1.4h0c.44-.33,1.07-.25,1.4,.19h0c.33,.44,.25,1.07-.19,1.4h0c-.18,.14-.4,.21-.61,.21h0c-.3,0-.6-.14-.79-.4Zm-3.9-5.97c-.27-.48-.1-1.09,.38-1.36h0c.48-.27,1.09-.09,1.36,.39h0c.27,.48,.1,1.09-.38,1.36h0c-.16,.08-.32,.13-.49,.13h0c-.35,0-.69-.19-.87-.52Zm-3.04-6.44h0c-.2-.52,.06-1.1,.57-1.3h0c.51-.2,1.09,.06,1.29,.57h0c.2,.52-.05,1.09-.56,1.3h0c-.12,.04-.25,.06-.37,.06h0c-.4,0-.78-.24-.93-.63Zm-2.11-6.82c-.13-.53,.2-1.07,.74-1.2h0c.54-.12,1.08,.21,1.2,.74h0c.13,.54-.2,1.08-.74,1.21h0c-.08,.02-.16,.02-.23,.02h0c-.46,0-.87-.3-.97-.77Zm-1.15-7.03c-.05-.55,.35-1.04,.9-1.09h0c.56-.05,1.04,.35,1.09,.9h0c.05,.55-.35,1.04-.9,1.09h-.1c-.51,0-.94-.39-.99-.9Zm.79-6.09c-.56-.02-.98-.49-.96-1.04h0c.03-.55,.5-.98,1.05-.95h0c.55,.02,.98,.49,.95,1.04h0c-.02,.54-.47,.95-1,.95h-.04Zm.65-6.96c-.54-.1-.9-.62-.8-1.16h0c.1-.55,.62-.91,1.16-.81h0c.55,.11,.91,.63,.81,1.17h0c-.09,.48-.51,.82-.99,.82h0c-.06,0-.12,0-.18-.02Zm1.61-6.8c-.52-.18-.81-.75-.63-1.27h0c.18-.52,.74-.81,1.27-.63h0c.52,.17,.8,.74,.63,1.26h0c-.14,.42-.53,.69-.95,.69h0c-.11,0-.21-.02-.32-.05Zm10.2-18.2c-.4-.37-.43-1-.06-1.41h0c.37-.41,1-.44,1.41-.06h0c.41,.37,.44,1,.07,1.41h0c-.2,.22-.47,.33-.74,.33h0c-.24,0-.48-.09-.68-.27Zm4.96-4.93c-.35-.42-.3-1.05,.13-1.41h0c.42-.35,1.05-.29,1.41,.13h0c.35,.42,.29,1.05-.13,1.41h0c-.19,.16-.42,.23-.64,.23h0c-.29,0-.57-.12-.77-.36Zm5.59-4.2c-.29-.47-.15-1.09,.32-1.38h0c.47-.29,1.08-.15,1.37,.32h0c.3,.47,.15,1.09-.32,1.38h0c-.16,.1-.34,.15-.52,.15h0c-.34,0-.66-.17-.85-.47Zm6.11-3.4c-.23-.5,0-1.09,.51-1.32h0c.51-.22,1.1,.01,1.32,.51h0c.23,.51,0,1.1-.5,1.32h0c-.14,.06-.27,.09-.41,.09h0c-.38,0-.75-.22-.91-.6Zm6.52-2.51c-.15-.53,.16-1.09,.69-1.24h0c.53-.15,1.08,.16,1.24,.69h0c.15,.53-.16,1.09-.69,1.24h0c-.09,.02-.18,.03-.27,.03h0c-.44,0-.84-.28-.97-.72Zm28.33,.65c-.53-.15-.84-.71-.69-1.24h0c.15-.53,.7-.84,1.23-.69h0c.53,.15,.85,.7,.69,1.24h0c-.12,.44-.52,.73-.96,.73h0c-.09,0-.18-.02-.27-.04Zm-21.51-2.23c-.08-.55,.3-1.06,.85-1.13h0c.54-.08,1.05,.3,1.12,.85h0c.08,.55-.3,1.05-.85,1.13h0s-.09,0-.14,0h0c-.49,0-.92-.36-.98-.86Zm14.8,.83c-.55-.07-.93-.58-.86-1.13h0c.08-.54,.59-.93,1.13-.85h0c.55,.07,.93,.58,.86,1.13h0c-.07,.5-.5,.86-.99,.86h0c-.05,0-.09,0-.14,0Zm-6.84-.46h0Zm-1-1c0-.55,.45-1,1-1h0c.55,0,1,.45,1,1h0c0,.55-.44,1-1,1h0c-.55,0-1-.44-1-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Objects"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 625.5,
    cy: 224.5,
    r: 70
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-21",
    cx: 165.79,
    cy: 188.65,
    r: 70.85
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 115,
    y1: 184,
    x2: 178,
    y2: 242
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 91,
    y1: 322,
    x2: 180,
    y2: 242
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 105.5,
    y1: 241.5,
    x2: 167.5,
    y2: 184.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 80.72,
    y1: 381.4,
    x2: 114.51,
    y2: 178.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 201.88,
    y1: 381.4,
    x2: 168.09,
    y2: 178.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 137.93,
    y: 182.2,
    width: 8.15,
    height: 195.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 107.52,
    y: 176.38,
    width: 67.33,
    height: 8.15,
    rx: 2,
    ry: 2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 109,
    y1: 208.52,
    x2: 174.24,
    y2: 208.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 102.01,
    y1: 242.31,
    x2: 180.06,
    y2: 242.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 128.61,
    y: 205.03,
    width: 26.79,
    height: 6.99,
    rx: 2,
    ry: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 128.61,
    y: 238.81,
    width: 26.79,
    height: 6.99,
    rx: 2,
    ry: 2
  }))), /*#__PURE__*/React.createElement("text", {
    className: "cls-19",
    transform: "translate(376 252)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "8b8896")), /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 256.5,
    cy: 118.5,
    r: 61
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-50"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 222.97,
    y: 104.07,
    width: 68.03,
    height: 14.01
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 222.97,
    y: 104.07,
    width: 68.03,
    height: 13.93
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 230.97,
    y: 118.08,
    width: 52.02,
    height: 4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 224.97,
    y: 106.07,
    width: 3,
    height: 3,
    rx: 1.5,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 230.47,
    y: 106.07,
    width: 3,
    height: 3,
    rx: 1.5,
    ry: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-53"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 284,
    y: 106.07,
    width: 1,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 287,
    y: 106.07,
    width: 1,
    height: 10
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 222.97,
    y: 122.07,
    width: 68.03,
    height: 14.01
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 222.97,
    y: 122.07,
    width: 68.03,
    height: 13.93
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 230.97,
    y: 136.08,
    width: 52.02,
    height: 4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 224.97,
    y: 124.07,
    width: 3,
    height: 3,
    rx: 1.5,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 230.47,
    y: 124.07,
    width: 3,
    height: 3,
    rx: 1.5,
    ry: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-53"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 284,
    y: 124.07,
    width: 1,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 287,
    y: 124.07,
    width: 1,
    height: 10
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: 222.97,
    y: 140.07,
    width: 68.03,
    height: 14.01
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 222.97,
    y: 140.07,
    width: 68.03,
    height: 13.93
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 230.97,
    y: 154.08,
    width: 52.02,
    height: 4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 224.97,
    y: 142.07,
    width: 3,
    height: 3,
    rx: 1.5,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 230.47,
    y: 142.07,
    width: 3,
    height: 3,
    rx: 1.5,
    ry: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-53"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 284,
    y: 142.07,
    width: 1,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 287,
    y: 142.07,
    width: 1,
    height: 10
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 222.97,
    y: 158.07,
    width: 68.03,
    height: 14.01
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 222.97,
    y: 158.07,
    width: 68.03,
    height: 13.93
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 230.97,
    y: 172.08,
    width: 52.02,
    height: 4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 224.97,
    y: 160.07,
    width: 3,
    height: 3,
    rx: 1.5,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 230.47,
    y: 160.07,
    width: 3,
    height: 3,
    rx: 1.5,
    ry: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-53"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 284,
    y: 160.07,
    width: 1,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 287,
    y: 160.07,
    width: 1,
    height: 10
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 222.97,
    y: 176.07,
    width: 68.03,
    height: 14.01
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 222.97,
    y: 176.07,
    width: 68.03,
    height: 13.93
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 230.97,
    y: 190.08,
    width: 52.02,
    height: 4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 224.97,
    y: 178.07,
    width: 3,
    height: 3,
    rx: 1.5,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 230.47,
    y: 178.07,
    width: 3,
    height: 3,
    rx: 1.5,
    ry: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-53"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 284,
    y: 178.07,
    width: 1,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 287,
    y: 178.07,
    width: 1,
    height: 10
  })))), /*#__PURE__*/React.createElement("circle", {
    className: "cls-21",
    cx: 509,
    cy: 183,
    r: 100.5
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-51"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 452.11,
    y: 171,
    width: 73.66,
    height: 125
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-31",
    cx: 459,
    cy: 181.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-31",
    cx: 464,
    cy: 181.5,
    r: 1.5
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 471.5,
    y: 180.27,
    width: 54.61,
    height: 2.17
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-31",
    cx: 459,
    cy: 197.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-31",
    cx: 464,
    cy: 197.5,
    r: 1.5
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 471.5,
    y: 196.27,
    width: 54.61,
    height: 2.17
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-29",
    cx: 459,
    cy: 213.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-29",
    cx: 464,
    cy: 213.5,
    r: 1.5
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 471.5,
    y: 212.27,
    width: 54.61,
    height: 2.17
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-29",
    cx: 459,
    cy: 229.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-29",
    cx: 464,
    cy: 229.5,
    r: 1.5
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 471.5,
    y: 228.27,
    width: 54.61,
    height: 2.17
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-29",
    cx: 459,
    cy: 246.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-29",
    cx: 464,
    cy: 246.5,
    r: 1.5
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 471.5,
    y: 245.27,
    width: 54.61,
    height: 2.17
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-29",
    cx: 459,
    cy: 264.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-29",
    cx: 464,
    cy: 264.5,
    r: 1.5
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 471.5,
    y: 263.27,
    width: 54.61,
    height: 2.17
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 510.68,
    y: 129,
    width: 95.32,
    height: 158
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-63",
    x: 606,
    y: 157,
    width: 7,
    height: 53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 512.85,
    y: 135.5,
    width: 90.99,
    height: 28.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 519.35,
    y: 139.83,
    width: 77.99,
    height: 19.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 525.85,
    y: 148.5,
    width: 43.33,
    height: 2.17
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-37",
    cx: 581.09,
    cy: 149.58,
    r: 1.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-37",
    cx: 589.21,
    cy: 149.58,
    r: 1.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 512.85,
    y: 204.82,
    width: 90.99,
    height: 44.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 519.35,
    y: 223.83,
    width: 77.99,
    height: 19.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 525.85,
    y: 232.5,
    width: 43.33,
    height: 2.17
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 581.09,
    cy: 233.58,
    r: 1.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 589.21,
    cy: 233.58,
    r: 1.62
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 512.85,
    y: 165.83,
    width: 90.99,
    height: 36.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 519.35,
    y: 171.24,
    width: 77.99,
    height: 7.58
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 525.3,
    cy: 175.03,
    r: 1.62
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-39",
    cx: 524.76,
    cy: 186.95,
    r: 1.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-39",
    cx: 532.34,
    cy: 186.95,
    r: 1.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-39",
    cx: 539.93,
    cy: 186.95,
    r: 1.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-39",
    cx: 547.51,
    cy: 186.95,
    r: 1.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-39",
    cx: 555.09,
    cy: 186.95,
    r: 1.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-39",
    cx: 562.67,
    cy: 186.95,
    r: 1.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-39",
    cx: 570.26,
    cy: 186.95,
    r: 1.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-39",
    cx: 577.84,
    cy: 186.95,
    r: 1.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-39",
    cx: 585.42,
    cy: 186.95,
    r: 1.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-39",
    cx: 593,
    cy: 186.95,
    r: 1.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-39",
    cx: 524.76,
    cy: 195.61,
    r: 1.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-39",
    cx: 532.34,
    cy: 195.61,
    r: 1.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-39",
    cx: 539.93,
    cy: 195.61,
    r: 1.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-39",
    cx: 547.51,
    cy: 195.61,
    r: 1.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-39",
    cx: 555.09,
    cy: 195.61,
    r: 1.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-39",
    cx: 562.67,
    cy: 195.61,
    r: 1.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-39",
    cx: 570.26,
    cy: 195.61,
    r: 1.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-39",
    cx: 577.84,
    cy: 195.61,
    r: 1.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-39",
    cx: 585.42,
    cy: 195.61,
    r: 1.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-39",
    cx: 593,
    cy: 195.61,
    r: 1.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-39",
    cx: 529.09,
    cy: 191.28,
    r: 1.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-39",
    cx: 536.68,
    cy: 191.28,
    r: 1.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-39",
    cx: 544.26,
    cy: 191.28,
    r: 1.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-39",
    cx: 551.84,
    cy: 191.28,
    r: 1.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-39",
    cx: 559.42,
    cy: 191.28,
    r: 1.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-39",
    cx: 567.01,
    cy: 191.28,
    r: 1.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-39",
    cx: 574.59,
    cy: 191.28,
    r: 1.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-39",
    cx: 582.17,
    cy: 191.28,
    r: 1.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-39",
    cx: 589.75,
    cy: 191.28,
    r: 1.62
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 530.72,
    cy: 175.03,
    r: 1.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 536.14,
    cy: 175.03,
    r: 1.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-37",
    cx: 585.96,
    cy: 175.03,
    r: 1.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-37",
    cx: 591.38,
    cy: 175.03,
    r: 1.62
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 512.85,
    y: 251.83,
    width: 90.99,
    height: 36.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 519.35,
    y: 257.24,
    width: 77.99,
    height: 7.58
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 525.3,
    cy: 261.03,
    r: 1.62
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-39",
    cx: 524.76,
    cy: 272.95,
    r: 1.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-39",
    cx: 532.34,
    cy: 272.95,
    r: 1.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-39",
    cx: 539.93,
    cy: 272.95,
    r: 1.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-39",
    cx: 547.51,
    cy: 272.95,
    r: 1.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-39",
    cx: 562.67,
    cy: 272.95,
    r: 1.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-39",
    cx: 570.26,
    cy: 272.95,
    r: 1.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-39",
    cx: 577.84,
    cy: 272.95,
    r: 1.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-39",
    cx: 585.42,
    cy: 272.95,
    r: 1.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-39",
    cx: 593,
    cy: 272.95,
    r: 1.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-39",
    cx: 524.76,
    cy: 281.61,
    r: 1.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-39",
    cx: 539.93,
    cy: 281.61,
    r: 1.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-39",
    cx: 547.51,
    cy: 281.61,
    r: 1.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-39",
    cx: 555.09,
    cy: 281.61,
    r: 1.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-39",
    cx: 562.67,
    cy: 281.61,
    r: 1.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-39",
    cx: 570.26,
    cy: 281.61,
    r: 1.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-39",
    cx: 577.84,
    cy: 281.61,
    r: 1.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-39",
    cx: 585.42,
    cy: 281.61,
    r: 1.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-39",
    cx: 593,
    cy: 281.61,
    r: 1.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-39",
    cx: 529.09,
    cy: 277.28,
    r: 1.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-39",
    cx: 536.68,
    cy: 277.28,
    r: 1.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-39",
    cx: 544.26,
    cy: 277.28,
    r: 1.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-39",
    cx: 551.84,
    cy: 277.28,
    r: 1.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-39",
    cx: 559.42,
    cy: 277.28,
    r: 1.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-39",
    cx: 567.01,
    cy: 277.28,
    r: 1.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-39",
    cx: 574.59,
    cy: 277.28,
    r: 1.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-39",
    cx: 582.17,
    cy: 277.28,
    r: 1.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-39",
    cx: 589.75,
    cy: 277.28,
    r: 1.62
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 530.72,
    cy: 261.03,
    r: 1.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 536.14,
    cy: 261.03,
    r: 1.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-26",
    cx: 585.96,
    cy: 261.03,
    r: 1.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-26",
    cx: 591.38,
    cy: 261.03,
    r: 1.62
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-43",
    points: "519.35 210.24 519.35 212.11 519.35 218 597.33 218 597.33 212.11 597.33 210.24 519.35 210.24"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-37",
    cx: 525.3,
    cy: 214.03,
    r: 1.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-37",
    cx: 530.72,
    cy: 214.03,
    r: 1.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-37",
    cx: 536.14,
    cy: 214.03,
    r: 1.62
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M162.4,250.38c-.24-1.17-.59-2.3-1.05-3.38-1.37-3.23-3.65-5.98-6.52-7.92-.48-.32-.97-.62-1.48-.9-2.55-1.38-5.47-2.17-8.58-2.17-.56,0-1.11,.03-1.66,.08-.16,.01-.32,.04-.48,.06-.4,.05-.8,.11-1.19,.18-.16,.03-.31,.06-.47,.09-.33,.07-.65,.16-.97,.25-.21-.75-.43-1.49-.7-2.22-.31-.86-.67-1.69-1.06-2.51-.2-.41-.4-.81-.62-1.2-.43-.79-.9-1.56-1.4-2.3s-1.04-1.46-1.61-2.15c-5.12-6.21-12.88-10.17-21.55-10.17,0,0-.02,0-.02,0-.45,0-.9,.01-1.34,.03-.16,0-.32,.02-.48,.03-.29,.02-.58,.04-.87,.07-.19,.02-.38,.04-.57,.07-.25,.03-.5,.06-.75,.1-.21,.03-.41,.06-.61,.1-.23,.04-.46,.08-.69,.12-.21,.04-.43,.09-.64,.13-.21,.05-.43,.1-.64,.15-.22,.05-.44,.11-.66,.17-.2,.05-.4,.11-.59,.17-.22,.07-.45,.13-.67,.2-.19,.06-.37,.12-.55,.19-.23,.08-.45,.15-.68,.24-.02,0-.05,.02-.08,.03-.04,.02-.08,.04-.12,.05-.56,.22-1.12,.45-1.67,.7-.08,.04-.16,.07-.24,.11-.58,.27-1.14,.56-1.7,.87-.08,.04-.16,.09-.24,.14-.52,.3-1.03,.61-1.53,.93-.05,.03-.1,.06-.15,.09-.53,.35-1.04,.72-1.54,1.11-.09,.07-.17,.14-.26,.2-.49,.39-.97,.78-1.43,1.2,0,0-.02,.01-.02,.02-.47,.42-.92,.87-1.36,1.32-.08,.09-.17,.17-.25,.26-.43,.46-.85,.93-1.26,1.42,0,0,0,0,0,.01-.39,.48-.77,.98-1.13,1.48-.07,.1-.15,.2-.22,.31-.35,.51-.69,1.03-1.01,1.56-.04,.06-.07,.13-.11,.2-.29,.49-.56,.98-.82,1.49-.06,.11-.11,.22-.17,.33-.1,.21-.2,.43-.3,.64-.28,.01-.56,.03-.84,.05-.18,.02-.37,.04-.55,.06-.4,.05-.8,.11-1.2,.18-.2,.04-.4,.07-.59,.12-.41,.09-.82,.2-1.22,.31-.15,.04-.29,.08-.44,.12-.03,0-.06,.02-.09,.02-.51,.16-1,.35-1.49,.55-.15,.06-.3,.14-.45,.21-.37,.17-.73,.34-1.09,.52-.19,.1-.37,.21-.56,.31-.31,.18-.62,.36-.92,.56-.18,.12-.36,.23-.53,.35-.32,.22-.62,.45-.93,.69-.14,.11-.28,.21-.41,.32-.42,.35-.83,.72-1.22,1.11-.09,.09-.17,.19-.26,.28-.3,.31-.59,.63-.87,.96-.13,.15-.25,.31-.37,.46-.23,.29-.45,.59-.67,.89-.12,.17-.24,.34-.35,.51-.21,.33-.42,.66-.61,1-.09,.15-.18,.3-.26,.45-.26,.5-.51,1-.73,1.52-.03,.07-.05,.14-.08,.2-.19,.46-.36,.93-.51,1.4-.06,.18-.11,.36-.16,.55-.11,.38-.21,.76-.29,1.15-.04,.2-.09,.4-.12,.61-.08,.4-.13,.8-.18,1.21-.02,.18-.05,.37-.07,.55-.03,.36-.05,.73-.06,1.09-.3,0-.6,.02-.89,.05-.19,.02-.37,.05-.56,.08-.14,.02-.27,.03-.41,.06-.01,0-.03,0-.04,0-.17,.03-.33,.08-.49,.12-.16,.04-.32,.08-.47,.12-.16,.05-.32,.1-.48,.16-.15,.05-.3,.1-.45,.16-.16,.06-.31,.13-.46,.2-.14,.07-.29,.13-.43,.21-.15,.08-.29,.15-.44,.23-.14,.08-.28,.16-.41,.25-.14,.09-.27,.17-.4,.26-.14,.1-.27,.2-.4,.3-.12,.09-.24,.18-.36,.28-.15,.12-.28,.25-.42,.38-.1,.09-.2,.17-.29,.27-.22,.22-.43,.45-.63,.69-.08,.09-.14,.19-.21,.28-.13,.16-.25,.33-.37,.5-.08,.11-.14,.22-.22,.34-.1,.16-.2,.32-.3,.49-.07,.12-.13,.24-.19,.37-.09,.17-.17,.34-.25,.51-.06,.13-.11,.26-.16,.38-.07,.18-.14,.36-.2,.54-.04,.13-.09,.26-.13,.39-.06,.19-.1,.39-.15,.59-.03,.13-.06,.25-.09,.38-.04,.22-.07,.45-.1,.67-.01,.11-.03,.22-.04,.33-.03,.34-.05,.68-.05,1.03,0,.37,.02,.73,.05,1.09,.22,2.15,1.07,4.11,2.38,5.69,.87,1.05,1.93,1.94,3.14,2.59,.6,.33,1.24,.6,1.91,.81,.95,.29,1.95,.45,2.99,.47h0s.18,0,.18,0h75.05s1.13-.05,1.13-.05c3.49-.22,6.71-1.42,9.38-3.34-.01,0-.01,0,0,0,.3-.22,1-.78,1.06-.83,.35-.29,.69-.6,1.01-.92,.07-.07,.14-.13,.21-.2,.35-.35,.67-.71,.99-1.09,.07-.09,.15-.18,.22-.27,.31-.39,.62-.79,.9-1.2,.03-.05,.06-.1,.09-.14,.26-.39,.51-.8,.74-1.21,.05-.09,.1-.17,.14-.26,.24-.44,.45-.89,.65-1.35,.04-.1,.08-.2,.12-.3,.2-.48,.38-.96,.54-1.46,0-.03,.01-.06,.02-.08,.15-.48,.27-.98,.38-1.48,.02-.1,.04-.2,.06-.29,.1-.51,.18-1.02,.24-1.55,.01-.1,.02-.21,.03-.31,.05-.55,.08-1.1,.08-1.65,0-1.24-.13-2.46-.37-3.63Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    className: "cls-41",
    d: "M114.42,236.24c3.05,0,5.52,2.45,5.52,5.48,0,2.07-1.16,3.87-2.86,4.8l.79,7.09c.03,.27-.17,.52-.44,.55h-.03s-5.93,0-5.93,0c-.28,0-.5-.22-.5-.5,0-.02,0-.04,0-.05l.79-7.09c-1.71-.93-2.86-2.73-2.86-4.8,0-3.02,2.47-5.48,5.52-5.48Z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-43",
    points: "592.94 129 606 129 606 159.25 592.94 129"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "595.31 135.5 603.83 135.5 603.83 154.97 595.31 135.5"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 519.35,
    y: 139.83,
    width: 77.99,
    height: 19.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M289.46,67.16c16.87,10.85,28.04,29.79,28.04,51.34,0,33.69-27.31,61-61,61-16.6,0-31.65-6.63-42.64-17.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M256.5,179.5c-33.69,0-61-27.31-61-61,0-8.98,1.94-17.52,5.43-25.2"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M601,223.52c-15.58,35.32-50.91,59.98-92,59.98-55.5,0-100.5-45-100.5-100.5s45-100.5,100.5-100.5c13.88,0,27.1,2.81,39.12,7.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M216.56,85.66c-.53,0-1.03,.07-1.52,.19,.13-.76,.19-1.54,.19-2.34,0-8.01-6.57-14.5-14.69-14.51-7.72,0-14.05,5.87-14.65,13.33-.07,0-.15-.01-.22-.01-3.58,0-6.6,2.33-7.6,5.53-.1,0-.2-.02-.3-.02-2.84,0-5.15,2.27-5.15,5.07,0,2.8,2.3,5.08,5.14,5.08,.02,0,.03,0,.05,0h0s38.73,.02,38.73,.02h0s0,0,0,0c3.46,0,6.26-2.76,6.26-6.17s-2.8-6.18-6.26-6.18Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M654.62,245.84c-.25-1.23-.62-2.42-1.1-3.55-1.44-3.39-3.83-6.28-6.85-8.32-.5-.34-1.02-.66-1.56-.95-2.68-1.46-5.75-2.28-9.01-2.28-.59,0-1.17,.04-1.74,.09-.17,.02-.34,.04-.51,.06-.42,.05-.84,.11-1.25,.19-.17,.03-.33,.06-.49,.1-.35,.07-.68,.17-1.02,.26-.22-.79-.46-1.57-.74-2.33-.33-.9-.7-1.78-1.11-2.63-.21-.43-.42-.85-.65-1.27-.45-.83-.94-1.64-1.47-2.42s-1.09-1.54-1.69-2.26c-5.39-6.53-13.54-10.69-22.66-10.69,0,0-.02,0-.02,0-.47,0-.94,.01-1.41,.04-.17,0-.34,.02-.5,.03-.3,.02-.61,.04-.91,.07-.2,.02-.4,.05-.6,.07-.26,.03-.53,.06-.79,.1-.22,.03-.43,.07-.65,.1-.24,.04-.48,.08-.72,.13-.22,.04-.45,.09-.67,.14-.22,.05-.45,.1-.67,.15-.23,.06-.46,.11-.69,.18-.21,.06-.42,.12-.62,.18-.23,.07-.47,.14-.7,.21-.2,.06-.39,.13-.58,.2-.24,.08-.48,.16-.71,.25-.03,0-.05,.02-.08,.03-.04,.02-.09,.04-.13,.05-.59,.23-1.18,.47-1.75,.74-.08,.04-.17,.07-.25,.11-.61,.29-1.2,.59-1.78,.92-.08,.05-.17,.1-.25,.14-.55,.31-1.08,.64-1.61,.98-.05,.03-.1,.06-.15,.1-.55,.37-1.09,.76-1.62,1.16-.09,.07-.18,.14-.27,.21-.51,.4-1.02,.82-1.5,1.26,0,0-.02,.01-.03,.02-.49,.45-.97,.91-1.43,1.39-.09,.09-.18,.18-.26,.27-.46,.48-.9,.98-1.32,1.49,0,0,0,0,0,.01-.41,.5-.81,1.03-1.19,1.56-.08,.11-.15,.21-.23,.32-.37,.53-.73,1.08-1.07,1.64-.04,.07-.08,.14-.12,.21-.3,.51-.59,1.04-.86,1.57-.06,.11-.12,.23-.18,.34-.11,.22-.22,.45-.32,.67-.3,.01-.59,.03-.88,.06-.19,.02-.38,.04-.58,.07-.42,.05-.84,.11-1.26,.19-.21,.04-.42,.08-.62,.12-.44,.1-.86,.21-1.29,.33-.15,.04-.31,.08-.46,.13-.03,0-.06,.02-.09,.03-.53,.17-1.05,.37-1.56,.58-.16,.07-.31,.14-.47,.22-.39,.17-.77,.35-1.15,.55-.2,.1-.39,.22-.59,.33-.33,.19-.65,.38-.97,.59-.19,.12-.38,.24-.56,.37-.33,.23-.66,.48-.97,.73-.14,.11-.29,.22-.44,.34-.44,.37-.87,.76-1.28,1.17-.1,.1-.18,.2-.28,.3-.32,.33-.62,.66-.92,1.01-.13,.16-.26,.32-.39,.49-.24,.31-.48,.62-.7,.94-.12,.18-.25,.35-.37,.54-.23,.34-.44,.7-.64,1.05-.09,.16-.19,.31-.27,.48-.28,.52-.54,1.05-.77,1.6-.03,.07-.05,.14-.08,.21-.2,.48-.38,.97-.54,1.47-.06,.19-.11,.38-.17,.57-.11,.4-.22,.8-.31,1.2-.05,.21-.09,.42-.13,.64-.08,.42-.14,.84-.19,1.27-.02,.19-.05,.38-.07,.58-.04,.38-.05,.76-.07,1.15-.32,0-.63,.02-.94,.05-.2,.02-.39,.06-.59,.08-.14,.02-.29,.03-.43,.06-.01,0-.03,0-.04,.01-.18,.03-.35,.08-.52,.12-.17,.04-.33,.08-.5,.13-.17,.05-.34,.11-.51,.17-.16,.05-.32,.11-.47,.17-.16,.07-.33,.14-.49,.21-.15,.07-.3,.14-.45,.22-.16,.08-.31,.16-.46,.25-.15,.08-.29,.17-.43,.26-.14,.09-.29,.18-.42,.28-.14,.1-.28,.21-.42,.32-.13,.1-.26,.19-.38,.3-.15,.13-.3,.27-.44,.4-.1,.09-.21,.18-.3,.28-.23,.23-.45,.48-.66,.73-.08,.09-.15,.2-.23,.29-.13,.17-.27,.34-.39,.52-.08,.12-.15,.24-.23,.35-.11,.17-.21,.34-.31,.52-.07,.13-.14,.26-.2,.39-.09,.18-.18,.36-.26,.54-.06,.13-.12,.27-.17,.4-.07,.19-.14,.38-.21,.57-.05,.14-.09,.27-.13,.41-.06,.2-.11,.41-.16,.62-.03,.13-.06,.27-.09,.4-.04,.23-.08,.47-.11,.7-.01,.12-.04,.23-.05,.35-.03,.36-.05,.72-.05,1.08,0,.39,.02,.77,.06,1.14,.23,2.26,1.13,4.32,2.5,5.98,.91,1.11,2.03,2.03,3.3,2.72,.63,.34,1.31,.63,2.01,.85,.99,.31,2.05,.48,3.14,.49h0s.19,0,.19,0h80.08v-.05c3.67-.23,7.05-1.49,9.86-3.51-.02,0-.02,0,0,0,.32-.23,.63-.47,.93-.72,.06-.05,.12-.11,.18-.16,.37-.31,.72-.63,1.06-.97,.07-.07,.15-.14,.22-.21,.36-.37,.71-.75,1.04-1.14,.08-.09,.15-.19,.23-.28,.33-.41,.65-.83,.94-1.26,.03-.05,.06-.1,.1-.15,.27-.41,.53-.84,.77-1.27,.05-.09,.1-.18,.15-.27,.25-.46,.48-.94,.68-1.42,.05-.1,.09-.21,.13-.32,.21-.5,.4-1.01,.56-1.54,0-.03,.02-.06,.02-.09,.16-.51,.29-1.03,.4-1.55,.02-.1,.05-.21,.07-.31,.11-.53,.19-1.08,.25-1.63,.01-.11,.02-.22,.03-.33,.05-.57,.09-1.15,.09-1.74,0-1.31-.13-2.58-.38-3.81Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-17-2",
    "data-name": "Group-17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape-2",
    "data-name": "Combined-Shape",
    className: "cls-41",
    d: "M604.18,230.98c3.2,0,5.8,2.58,5.8,5.76,0,2.17-1.22,4.07-3.01,5.05l.83,7.46c.03,.29-.18,.55-.47,.58h-.03s-6.23,0-6.23,0c-.29,0-.53-.23-.53-.52,0-.02,0-.04,0-.06l.83-7.45c-1.79-.98-3.01-2.87-3.01-5.05,0-3.18,2.6-5.76,5.8-5.76Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 641.58,
    y: 144,
    width: 90.42,
    height: 61.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-62",
    x: 641.58,
    y: 144,
    width: 90.42,
    height: 61.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 641.58,
    y: 144,
    width: 90.42,
    height: 8.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 641.58,
    y1: 152.74,
    x2: 732,
    y2: 152.74
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 641.58,
    y: 153,
    width: 90.42,
    height: 52.81
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M676.16,179.42h-3.77c0-4.33-3.39-7.85-7.56-7.85v-3.77c6.25,0,11.33,5.21,11.33,11.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M664.83,191.07c-6.23,0-11.3-5.23-11.3-11.65,0-6.42,5.07-11.65,11.3-11.65v3.83c-4.18,0-7.59,3.51-7.59,7.82,0,4.31,3.4,7.82,7.59,7.82,4.18,0,7.59-3.51,7.59-7.82h3.71c0,6.42-5.07,11.65-11.3,11.65Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 695.74,
    y: 173.77,
    width: 22.6,
    height: 2.91,
    transform: "translate(1414.08 350.45) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 695.74,
    y: 179.59,
    width: 19.78,
    height: 2.91,
    transform: "translate(1411.25 362.1) rotate(180)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 687.26,
    y: 173.77,
    width: 2.83,
    height: 2.91,
    transform: "translate(1377.34 350.45) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 687.26,
    y: 179.59,
    width: 2.83,
    height: 2.91,
    transform: "translate(1377.34 362.1) rotate(180)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M475.53,112.08c-.15-.75-.38-1.48-.68-2.17-.88-2.08-2.35-3.85-4.2-5.1-.31-.21-.63-.4-.96-.58-1.64-.89-3.52-1.4-5.52-1.4-.36,0-.72,.02-1.07,.05-.1,0-.21,.02-.31,.04-.26,.03-.51,.07-.77,.12-.1,.02-.2,.04-.3,.06-.22,.05-.43,.11-.64,.16-1.46-5.34-5.3-9.69-10.33-11.82-.54-.23-1.09-.43-1.65-.6-1.13-.35-2.3-.59-3.51-.72-.6-.06-1.22-.09-1.84-.09s-1.17,.03-1.75,.09c-.2,.02-.39,.06-.59,.08-.37,.05-.75,.1-1.11,.17-.23,.05-.46,.1-.69,.16-.32,.08-.64,.15-.95,.25-.24,.07-.47,.15-.71,.23-.18,.06-.36,.11-.53,.17-.13,.05-.26,.11-.38,.16-.18,.07-.36,.15-.53,.22-.34,.15-.67,.31-1,.48-.14,.07-.29,.14-.43,.22-.45,.25-.89,.51-1.31,.8-.11,.07-.21,.15-.32,.23-.32,.23-.64,.46-.95,.71-.14,.12-.28,.24-.42,.35-.27,.23-.53,.47-.79,.72-.13,.12-.25,.24-.38,.37-.32,.33-.63,.67-.93,1.02-.04,.05-.08,.09-.12,.13-.33,.4-.63,.81-.93,1.24-.09,.13-.18,.27-.27,.41-.2,.31-.39,.62-.58,.95-.09,.16-.17,.31-.26,.47-.14,.27-.27,.54-.4,.81-.18,0-.37,.02-.55,.03-.12,.01-.24,.03-.35,.04-.26,.03-.52,.07-.77,.12-.13,.02-.25,.05-.38,.08-.27,.06-.53,.13-.79,.2-.09,.03-.19,.05-.28,.08-.02,0-.04,0-.06,.02-.33,.1-.64,.22-.96,.36-.1,.04-.19,.09-.29,.13-.24,.11-.47,.22-.7,.34-.12,.06-.24,.13-.36,.2-.2,.11-.4,.23-.59,.36-.12,.07-.23,.15-.34,.23-.2,.14-.4,.29-.6,.45-.09,.07-.18,.14-.27,.21-.27,.23-.54,.47-.79,.71-.06,.06-.11,.12-.17,.18-.19,.2-.38,.41-.56,.62-.08,.1-.16,.2-.24,.3-.15,.19-.29,.38-.43,.57-.08,.11-.15,.22-.22,.33-.14,.21-.27,.43-.39,.65-.06,.1-.11,.19-.17,.29-.17,.32-.33,.64-.47,.98-.02,.04-.03,.09-.05,.13-.12,.3-.23,.6-.33,.9-.04,.12-.07,.23-.1,.35-.07,.24-.13,.49-.19,.74-.03,.13-.06,.26-.08,.39-.05,.26-.09,.52-.12,.78-.01,.12-.03,.24-.04,.36-.02,.23-.03,.47-.04,.7-.19,0-.39,.01-.57,.03-.12,.01-.24,.03-.36,.05-.09,.01-.18,.02-.26,.04,0,0-.01,0-.02,0-.36,.07-.71,.17-1.05,.3-.04,.02-.09,.03-.13,.05-.33,.13-.64,.28-.94,.46-.04,.03-.08,.05-.13,.08-.3,.18-.59,.39-.86,.61-.02,.02-.05,.04-.07,.06-.27,.23-.52,.49-.75,.76,0,0-.02,.02-.02,.03-.23,.27-.43,.56-.61,.87-.03,.04-.05,.09-.08,.13-.17,.3-.31,.61-.44,.93-.02,.06-.04,.11-.06,.17-.12,.33-.21,.66-.28,1.01,0,.05-.01,.1-.02,.15-.06,.37-.1,.74-.1,1.13,0,3.75,3.01,6.79,6.74,6.85h0s.11,0,.11,0h48.32s.73-.03,.73-.03c5.09,.03,8.23-4.23,8.28-4.28,.2-.25,.4-.51,.58-.77,.02-.03,.04-.06,.06-.09,.17-.25,.33-.51,.47-.78,.03-.05,.06-.11,.09-.16,.15-.28,.29-.57,.42-.87,.03-.06,.05-.13,.08-.19,.13-.31,.24-.62,.34-.94,0-.02,0-.04,.02-.05,.1-.31,.18-.63,.25-.95,.01-.06,.03-.13,.04-.19,.06-.33,.12-.66,.15-1,0-.07,.01-.13,.02-.2,.03-.35,.05-.71,.05-1.07,0-.8-.08-1.58-.24-2.33Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-17-3",
    "data-name": "Group-17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape-3",
    "data-name": "Combined-Shape",
    className: "cls-41",
    d: "M444.64,102.98c1.96,0,3.55,1.58,3.55,3.53,0,1.33-.74,2.49-1.84,3.09l.51,4.57c.02,.18-.11,.33-.29,.35h-.02s-3.82,0-3.82,0c-.18,0-.32-.14-.32-.32,0-.01,0-.02,0-.04l.51-4.57c-1.1-.6-1.84-1.76-1.84-3.09,0-1.95,1.59-3.53,3.55-3.53Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M179.15,270.51c-.66,0-1.3,.09-1.91,.24,.16-.96,.24-1.94,.24-2.94,0-10.04-8.25-18.19-18.43-18.19s-17.62,7.37-18.37,16.73c-.09,0-.18-.01-.28-.01-4.49,0-8.28,2.92-9.53,6.95-.13,0-.25-.02-.38-.02-3.56,0-6.45,2.85-6.45,6.37s2.89,6.37,6.45,6.37c.02,0,.04,0,.07,0h0s48.58,0,48.58,0h0s0,0,0,0c4.34,0,7.85-3.47,7.85-7.74s-3.51-7.74-7.85-7.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M318.05,161.65c-.53,0-1.03,.07-1.52,.19,.13-.76,.19-1.54,.19-2.34,0-8.01-6.58-14.5-14.7-14.5s-14.04,5.87-14.65,13.34c-.07,0-.15-.01-.22-.01-3.58,0-6.6,2.33-7.59,5.54-.1,0-.2-.02-.3-.02-2.84,0-5.15,2.27-5.15,5.08s2.3,5.08,5.15,5.08c.02,0,.03,0,.05,0h0s38.73,0,38.73,0h0s0,0,0,0c3.46,0,6.26-2.76,6.26-6.17s-2.8-6.17-6.26-6.17Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M140.19,122.83l-.04-.03v57.27s3.72-.04,3.72-.04l-.07-33.91v-23.32h0c-1.09,.73-2.51,.74-3.61,.03Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-38",
    cx: 142,
    cy: 120,
    r: 3
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 126.5,
    y1: 144.64,
    x2: 156.5,
    y2: 144.64
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M131.58,170.55h20.61c1.71,0,3.09,1.39,3.09,3.09v7.39h-26.79v-7.39c0-1.71,1.39-3.09,3.09-3.09Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 148,
    y: 125,
    width: 13,
    height: 40,
    rx: 5.01,
    ry: 5.01
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 123,
    y: 125,
    width: 13,
    height: 40,
    rx: 5.01,
    ry: 5.01
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-38",
    cx: 547,
    cy: 329,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 547,
    cy: 329,
    r: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-38",
    cx: 550,
    cy: 91,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 550,
    cy: 91,
    r: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-38",
    cx: 426,
    cy: 27,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 426,
    cy: 27,
    r: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-38",
    cx: 288,
    cy: 66,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 288,
    cy: 66,
    r: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-38",
    cx: 180,
    cy: 331,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 180,
    cy: 331,
    r: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-38",
    cx: 36,
    cy: 193,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 36,
    cy: 193,
    r: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Desk"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-59"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-21",
    cx: 370.75,
    cy: 533.5,
    rx: 85,
    ry: 23.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-21",
    cx: 368.75,
    cy: 523,
    rx: 174.5,
    ry: 18
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M501.78,521.5c-1.38,0-2.5-1.12-2.5-2.5v-144c0-1.38,1.12-2.5,2.5-2.5s2.5,1.12,2.5,2.5v144c0,1.38-1.12,2.5-2.5,2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M235.78,521.5c-1.38,0-2.5-1.12-2.5-2.5v-144c0-1.38,1.12-2.5,2.5-2.5s2.5,1.12,2.5,2.5v144c0,1.38-1.12,2.5-2.5,2.5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 220.28,
    y: 353,
    width: 297,
    height: 22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 225,
    y: 375,
    width: 284,
    height: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Screen"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 253.78,
    y: 204,
    width: 230,
    height: 135
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 254,
    y: 204,
    width: 229.78,
    height: 135
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-58"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M276.2,285.22c-.28,0-.5-.22-.5-.5v-1c0-.28,.22-.5,.5-.5s.5,.22,.5,.5v1c0,.28-.22,.5-.5,.5Zm0-3c-.28,0-.5-.22-.5-.5v-1c0-.28,.22-.5,.5-.5s.5,.22,.5,.5v1c0,.28-.22,.5-.5,.5Zm0-3c-.28,0-.5-.22-.5-.5v-1c0-.28,.22-.5,.5-.5s.5,.22,.5,.5v1c0,.28-.22,.5-.5,.5Zm0-3c-.28,0-.5-.22-.5-.5v-1c0-.28,.22-.5,.5-.5s.5,.22,.5,.5v1c0,.28-.22,.5-.5,.5Zm0-3c-.28,0-.5-.22-.5-.5v-1c0-.28,.22-.5,.5-.5s.5,.22,.5,.5v1c0,.28-.22,.5-.5,.5Zm0-3c-.28,0-.5-.22-.5-.5v-1c0-.28,.22-.5,.5-.5s.5,.22,.5,.5v1c0,.28-.22,.5-.5,.5Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M276.26,281.21c.99,0,1.96,.49,2.53,1.39,.89,1.4,.48,3.25-.92,4.14-.5,.32-1.06,.47-1.61,.47-.99,0-1.96-.49-2.53-1.39-.89-1.4-.48-3.25,.92-4.14,.5-.32,1.06-.47,1.61-.47m0-1h0c-.76,0-1.5,.22-2.14,.63-.9,.57-1.53,1.46-1.76,2.51s-.04,2.11,.53,3.02c.74,1.16,2,1.85,3.38,1.85,.76,0,1.5-.22,2.14-.62,1.86-1.18,2.41-3.66,1.23-5.52-.74-1.16-2-1.85-3.38-1.85h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M276.27,286.96c-.95,0-1.81-.48-2.32-1.27-.81-1.28-.44-2.98,.84-3.8,.44-.28,.95-.43,1.47-.43,.95,0,1.81,.48,2.32,1.27,.81,1.28,.44,2.98-.84,3.8-.44,.28-.95,.43-1.47,.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M276.26,281.96c.74,0,1.47,.37,1.9,1.04,.67,1.05,.36,2.44-.69,3.11-.37,.24-.79,.35-1.21,.35-.74,0-1.47-.37-1.9-1.04-.67-1.05-.36-2.44,.69-3.11,.37-.24,.79-.35,1.21-.35m0-1h0c-.62,0-1.22,.18-1.74,.51-.73,.47-1.24,1.19-1.43,2.04-.19,.85-.04,1.72,.43,2.45,.6,.94,1.63,1.51,2.74,1.51,.62,0,1.22-.18,1.74-.51,1.51-.96,1.96-2.97,1-4.49-.6-.94-1.63-1.51-2.74-1.51h0Z"
  }))))), /*#__PURE__*/React.createElement("g", {
    className: "cls-58"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M287.22,251.88c-.09,0-.19-.03-.28-.08l-.83-.55c-.23-.15-.29-.46-.14-.69,.15-.23,.46-.3,.69-.14l.83,.55c.23,.15,.29,.46,.14,.69-.1,.15-.25,.22-.42,.22Zm-2.5-1.65c-.09,0-.19-.03-.28-.08l-.83-.55c-.23-.15-.29-.46-.14-.69,.15-.23,.46-.29,.69-.14l.83,.55c.23,.15,.29,.46,.14,.69-.1,.15-.26,.22-.42,.22Zm-2.5-1.65c-.09,0-.19-.03-.28-.08l-.83-.55c-.23-.15-.29-.46-.14-.69,.15-.23,.46-.3,.69-.14l.83,.55c.23,.15,.29,.46,.14,.69-.1,.15-.25,.22-.42,.22Zm-2.5-1.65c-.09,0-.19-.03-.28-.08l-.83-.55c-.23-.15-.29-.46-.14-.69,.15-.23,.46-.29,.69-.14l.83,.55c.23,.15,.29,.46,.14,.69-.1,.15-.26,.22-.42,.22Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M273.77,239.51c.45,0,.91,.1,1.34,.32,1.48,.74,2.08,2.54,1.34,4.02-.53,1.05-1.59,1.66-2.69,1.66-.45,0-.91-.1-1.34-.32-1.48-.74-2.08-2.54-1.34-4.02,.53-1.05,1.59-1.66,2.69-1.66m0-1h0c-1.53,0-2.9,.85-3.58,2.21-.98,1.97-.18,4.38,1.79,5.37,.56,.28,1.16,.42,1.78,.42,1.53,0,2.9-.85,3.58-2.21,.98-1.97,.18-4.38-1.79-5.37-.56-.28-1.16-.42-1.78-.42h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M273.76,245.26c-.43,0-.84-.1-1.23-.29-.66-.33-1.15-.89-1.38-1.59-.23-.7-.18-1.44,.15-2.1,.47-.94,1.41-1.52,2.46-1.52,.43,0,.84,.1,1.23,.29,.66,.33,1.15,.89,1.38,1.59,.23,.7,.18,1.44-.15,2.1-.47,.94-1.41,1.52-2.46,1.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M273.77,240.26c.34,0,.68,.08,1,.24,1.11,.56,1.56,1.91,1.01,3.02-.39,.79-1.19,1.25-2.01,1.25-.34,0-.68-.08-1-.24-1.11-.55-1.56-1.91-1.01-3.02,.39-.79,1.19-1.25,2.01-1.25m0-1h0c-1.24,0-2.36,.69-2.91,1.8-.39,.78-.45,1.66-.17,2.48,.28,.82,.85,1.49,1.63,1.88,.46,.23,.94,.34,1.45,.34,1.24,0,2.36-.69,2.91-1.8,.8-1.6,.15-3.56-1.46-4.36-.46-.23-.94-.34-1.45-.34h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-58"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M321.39,275.68c-.14,0-.29-.06-.39-.18l-.63-.77c-.17-.21-.14-.53,.07-.7,.21-.17,.53-.14,.7,.07l.63,.77c.17,.21,.14,.53-.07,.7-.09,.08-.21,.11-.32,.11Zm-1.9-2.32c-.14,0-.29-.06-.39-.18l-.63-.77c-.17-.21-.14-.53,.07-.7,.21-.17,.53-.14,.7,.07l.63,.77c.17,.21,.14,.53-.07,.7-.09,.08-.21,.11-.32,.11Zm-1.9-2.32c-.14,0-.29-.06-.39-.18l-.63-.77c-.17-.21-.14-.53,.07-.7,.21-.17,.53-.14,.7,.07l.63,.77c.17,.21,.14,.53-.07,.7-.09,.08-.21,.11-.32,.11Zm-1.9-2.32c-.14,0-.29-.06-.39-.18l-.63-.77c-.17-.21-.14-.53,.07-.7,.21-.17,.53-.14,.7,.07l.63,.77c.17,.21,.14,.53-.07,.7-.09,.08-.21,.11-.32,.11Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M325.28,276.91c.75,0,1.49,.28,2.07,.83,1.2,1.15,1.24,3.04,.09,4.24-.59,.62-1.38,.93-2.17,.93-.75,0-1.49-.28-2.07-.83-1.2-1.15-1.24-3.04-.09-4.24,.59-.62,1.38-.93,2.17-.93m0-1h0c-1.1,0-2.13,.44-2.89,1.23-1.52,1.59-1.47,4.13,.13,5.66,.75,.72,1.73,1.11,2.76,1.11,1.1,0,2.13-.44,2.89-1.23,1.52-1.59,1.47-4.13-.13-5.66-.75-.72-1.73-1.11-2.76-1.11h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M325.28,282.66c-.71,0-1.39-.27-1.9-.76-1.09-1.05-1.13-2.79-.09-3.89,.52-.55,1.23-.85,1.99-.85,.71,0,1.39,.27,1.9,.76,.53,.51,.83,1.19,.85,1.93s-.25,1.43-.76,1.96c-.52,.55-1.23,.85-1.99,.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M325.28,277.65c.56,0,1.12,.21,1.55,.62,.9,.86,.93,2.28,.07,3.18-.44,.46-1.03,.69-1.63,.69-.56,0-1.12-.21-1.55-.62-.9-.86-.93-2.28-.07-3.18,.44-.46,1.03-.7,1.63-.7m0-1c-.9,0-1.73,.36-2.35,1-.6,.63-.92,1.45-.9,2.32,.02,.87,.38,1.68,1,2.28,.61,.58,1.41,.9,2.25,.9,.9,0,1.73-.36,2.35-1,1.24-1.3,1.19-3.36-.1-4.6-.61-.58-1.41-.9-2.25-.9h0Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 275.99,
    y1: 262.64,
    x2: 288.09,
    y2: 250.06
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M275.96,260.16c.72,0,1.44,.26,2.02,.78,1.23,1.12,1.31,3.01,.2,4.24-.59,.65-1.4,.98-2.22,.98-.72,0-1.44-.26-2.02-.78-1.23-1.12-1.31-3.01-.2-4.24,.59-.65,1.4-.98,2.22-.98m0-1h0c-1.12,0-2.2,.48-2.96,1.31-.72,.79-1.09,1.81-1.04,2.88,.05,1.07,.51,2.05,1.3,2.77,.74,.67,1.69,1.04,2.69,1.04,1.12,0,2.2-.48,2.96-1.31,.72-.79,1.09-1.81,1.04-2.88-.05-1.07-.51-2.05-1.3-2.77-.74-.67-1.69-1.04-2.69-1.04h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M275.96,265.91c-.69,0-1.34-.25-1.85-.72-1.12-1.02-1.2-2.76-.18-3.89,.52-.57,1.26-.9,2.04-.9,.69,0,1.34,.25,1.85,.72,1.12,1.02,1.2,2.76,.18,3.89-.52,.57-1.26,.9-2.04,.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M275.96,260.91c.54,0,1.08,.19,1.51,.59,.92,.84,.99,2.26,.15,3.18-.44,.49-1.05,.74-1.66,.74-.54,0-1.08-.19-1.51-.59-.92-.84-.99-2.26-.15-3.18,.44-.49,1.05-.74,1.66-.74m0-1h0c-.91,0-1.79,.39-2.4,1.06-.58,.64-.88,1.47-.84,2.34,.04,.87,.42,1.67,1.06,2.25,.6,.55,1.38,.85,2.19,.85,.91,0,1.79-.39,2.4-1.06,.58-.64,.88-1.47,.84-2.34s-.42-1.67-1.06-2.25c-.6-.55-1.38-.85-2.19-.85h0Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 296.5,
    y1: 256.5,
    x2: 284.46,
    y2: 249.41
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M286.95,247.71c1.02,0,2.01,.52,2.57,1.46,.85,1.42,.39,3.26-1.03,4.12-.48,.29-1.02,.43-1.54,.43-1.02,0-2.01-.52-2.57-1.46-.85-1.42-.39-3.26,1.03-4.12,.48-.29,1.02-.43,1.54-.43m0-1h0c-.72,0-1.43,.2-2.06,.57-1.89,1.14-2.5,3.6-1.37,5.49,.72,1.2,2.03,1.94,3.43,1.94,.72,0,1.43-.2,2.06-.57,1.89-1.14,2.5-3.6,1.37-5.49-.72-1.2-2.03-1.94-3.43-1.94h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M286.96,253.46c-.96,0-1.87-.51-2.36-1.33-.38-.63-.49-1.37-.31-2.08s.62-1.31,1.25-1.69c.43-.26,.92-.39,1.41-.39,.96,0,1.87,.51,2.36,1.33,.38,.63,.49,1.37,.31,2.08-.18,.71-.62,1.31-1.25,1.69-.43,.26-.92,.39-1.41,.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M286.95,248.46c.76,0,1.51,.39,1.93,1.09,.64,1.07,.3,2.45-.77,3.09-.36,.22-.76,.32-1.16,.32-.76,0-1.51-.39-1.93-1.09-.64-1.07-.3-2.45,.77-3.09,.36-.22,.76-.32,1.16-.32m0-1h0c-.59,0-1.17,.16-1.67,.46-.74,.45-1.27,1.16-1.48,2s-.08,1.72,.37,2.46c.58,.97,1.65,1.58,2.79,1.58,.59,0,1.17-.16,1.67-.46,1.54-.92,2.04-2.92,1.11-4.46-.58-.97-1.65-1.58-2.79-1.58h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-58"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M305.84,251.02c-.28,0-.5-.22-.5-.5v-1c0-.28,.22-.5,.5-.5s.5,.22,.5,.5v1c0,.28-.22,.5-.5,.5Zm0-3c-.28,0-.5-.22-.5-.5v-1c0-.28,.22-.5,.5-.5s.5,.22,.5,.5v1c0,.28-.22,.5-.5,.5Zm0-3c-.28,0-.5-.22-.5-.5v-1c0-.28,.22-.5,.5-.5s.5,.22,.5,.5v1c0,.28-.22,.5-.5,.5Zm0-3c-.28,0-.5-.22-.5-.5v-1c0-.28,.22-.5,.5-.5s.5,.22,.5,.5v1c0,.28-.22,.5-.5,.5Zm0-3c-.28,0-.5-.22-.5-.5v-.53c0-.28,.22-.5,.5-.5s.5,.22,.5,.5v.53c0,.28-.22,.5-.5,.5Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M305.84,229.74c1.66,0,3,1.34,3,3s-1.34,3-3,3-3-1.34-3-3,1.34-3,3-3m0-1c-2.21,0-4,1.79-4,4s1.79,4,4,4,4-1.79,4-4-1.79-4-4-4h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-38",
    cx: 305.84,
    cy: 232.74,
    r: 2.75
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M305.84,230.49c1.24,0,2.25,1.01,2.25,2.25s-1.01,2.25-2.25,2.25-2.25-1.01-2.25-2.25,1.01-2.25,2.25-2.25m0-1c-1.79,0-3.25,1.46-3.25,3.25s1.46,3.25,3.25,3.25,3.25-1.46,3.25-3.25-1.46-3.25-3.25-3.25h0Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 330.08,
    y1: 243.81,
    x2: 314.98,
    y2: 253.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M328.68,241.57c1.52,0,2.82,1.15,2.98,2.69,.17,1.65-1.03,3.12-2.68,3.29-.1,.01-.21,.02-.31,.02-1.52,0-2.82-1.15-2.98-2.69-.17-1.65,1.03-3.12,2.68-3.29,.1-.01,.21-.02,.31-.02m0-1h0c-.14,0-.27,0-.41,.02-2.19,.23-3.8,2.19-3.57,4.39,.21,2.05,1.92,3.59,3.98,3.59,.14,0,.27,0,.41-.02,1.06-.11,2.02-.62,2.69-1.45,.67-.83,.99-1.87,.88-2.93-.21-2.05-1.92-3.59-3.98-3.59h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M328.68,247.32c-1.42,0-2.59-1.06-2.73-2.47-.16-1.51,.95-2.86,2.45-3.02,.09,0,.19-.01,.28-.01,1.41,0,2.59,1.06,2.73,2.47,.15,1.51-.95,2.86-2.46,3.02-.09,0-.19,.01-.28,.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M328.68,242.32c1.14,0,2.12,.86,2.24,2.02,.13,1.24-.77,2.34-2.01,2.47-.08,0-.16,.01-.23,.01-1.14,0-2.12-.86-2.24-2.02-.13-1.24,.77-2.34,2.01-2.47,.08,0,.16-.01,.23-.01m0-1c-.11,0-.22,0-.33,.02-1.78,.18-3.08,1.78-2.9,3.56,.17,1.66,1.56,2.92,3.23,2.92,.11,0,.22,0,.33-.02,1.78-.18,3.08-1.78,2.9-3.56-.17-1.66-1.56-2.92-3.23-2.92h0Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M310.74,251.48c1,.62,1.9,1.43,2.65,2.42,3.35,4.39,2.51,10.66-1.87,14.02"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 305.45,
    cy: 259.97,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 305.45,
    cy: 259.97,
    r: 4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M297.5,266.04c-.75-.99-1.3-2.07-1.63-3.19-1.16-3.87,.11-8.22,3.51-10.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M297.5,266.04c-.75-.99-1.3-2.07-1.63-3.19-1.16-3.87,.11-8.22,3.51-10.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M310.74,251.48c1,.62,1.9,1.43,2.65,2.42,3.35,4.39,2.51,10.66-1.87,14.02"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 253.78,
    y: 204,
    width: 230,
    height: 9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 259.28,
    cy: 208.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 264.28,
    cy: 208.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 269.28,
    cy: 208.5,
    r: 1.5
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 430.78,
    y: 213,
    width: 53,
    height: 126
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 439.93,
    y1: 264.37,
    x2: 474.78,
    y2: 264.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 439.93,
    y1: 269.84,
    x2: 474.78,
    y2: 269.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 439.93,
    y1: 275.85,
    x2: 467.74,
    y2: 275.85
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 439.93,
    y1: 294.87,
    x2: 474.78,
    y2: 294.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 439.93,
    y1: 300.34,
    x2: 474.78,
    y2: 300.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 439.93,
    y1: 306.35,
    x2: 467.74,
    y2: 306.35
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 439.93,
    y1: 233.87,
    x2: 474.78,
    y2: 233.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 439.93,
    y1: 239.34,
    x2: 474.78,
    y2: 239.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 439.93,
    y1: 245.35,
    x2: 467.74,
    y2: 245.35
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M252.17,328.95c-3.84-2.22-6.42-5.78-7.48-9.76s-.61-8.35,1.6-12.19c7.69,4.44,10.32,14.26,5.88,21.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M252.74,328.95c3.84-2.22,6.42-5.78,7.49-9.76,1.06-3.97,.61-8.35-1.61-12.19-7.68,4.44-10.32,14.26-5.88,21.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M252.18,329.89c-9.83,0-17.79-7.97-17.79-17.79h.22c9.83,0,17.79,7.97,17.79,17.79h-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M270.15,312.21c0,9.83-7.97,17.79-17.79,17.79v-.22c0-9.83,7.97-17.79,17.79-17.79v.22Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M235.46,329.73v6.19c0,9.28,7.53,16.81,16.81,16.81s16.81-7.53,16.81-16.81v-6.19h-33.62Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Person_copy",
    "data-name": "Person copy"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M407.64,349.05c-9.86,1.48-19.8,2.72-19.8,2.72l4.16,12.76s6.99,.27,15.85,.2l-1-2.53c-1.7-4.3-1.38-9.11,.79-13.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M389.8,256.2l-.11-.02c.39-1.54,.63-3.14,.63-4.8,0-10.67-8.65-19.32-19.32-19.32s-19.03,8.39-19.3,18.83h-.02s-.19,2.26-.55,5.12c-.37,2.87-1.25,5.14-1.1,8.75,.3,7.14,2.57,15.29,4.69,16.67,1.51,.98,3.63,1.47,6.45,.61v15.39h22.81s-2.64-12.21-2.64-16.34c0-10.28,3.98-14.88,6.05-19.5,.92-1.48,1.65-3.08,2.15-4.79,.17-.38,.27-.6,.27-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M361.05,277.27c-.36,1.37-1.13,2.71-2.37,3.41-1.06,.6-2.74,.68-4.01,.73,0,0,.02,.02,.03,.02,.55,.36,1.18,.65,1.89,.83,.95,.25,2.05,.3,3.3,.08,.4-.07,.82-.17,1.26-.3v-5.31c-.04,.18-.06,.36-.11,.54Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M357.16,235.98c-1.2,1-2.27,2.19-3.16,3.59,.93-1.3,1.99-2.51,3.16-3.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M393.73,263.3c1.78-6.99,1.06-14.43,.41-16.68-1.88-6.54-5.93-15.81-22.76-15.39-4.72,.12-10.18,1.39-14.22,4.75-1.17,1.08-2.23,2.29-3.16,3.59-1.08,1.7-1.9,3.69-2.33,6.06-.29,1.58-.99,5.93,2.34,8.33,.25,4.2-2.2,9.43,2.99,15.41,.2,.23,.58,0,.47-.28-.99-2.57-1.79-6.96-.32-9.94,.47-.95,1.84-1.72,2.77-1.22,2.9,1.55,1.1,5.76,2.9,10.81,1.4,3.94,3.7,6.07,6.42,7.22,1.19,.19,2.42,.29,3.66,.29,9.14,0,17.04-5.28,20.83-12.96Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M394.9,235.83c-1.88,0-3.66,.4-5.28,1.11-4.22-4.39-10.15-7.12-16.72-7.12-6.08,0-11.6,2.34-15.74,6.16-1.17,1.08-2.23,2.29-3.16,3.59-1.08,1.7-1.9,3.69-2.33,6.06-.29,1.58-.99,5.93,2.34,8.33,.25,4.2-2.2,9.43,2.99,15.41,.2,.23,.58,0,.47-.28-.99-2.57-1.79-6.96-.32-9.94,.47-.95,1.84-1.72,2.77-1.22,2.9,1.55,1.1,5.76,2.9,10.81,1.4,3.94,3.7,6.07,6.42,7.22,1.18,.5,2.45,.81,3.76,1,2.02,.76,4.03,1.55,6.18,1.83,1.51,.2,3.05,.13,4.51-.31,1.41-.43,2.71-1.23,3.96-1.99,1.78-1.09,2.98-2.78,3.93-4.61,1.08-2.07,1.85-4.31,2.43-6.57,.28-1.08,.52-2.19,.7-3.3,.06,0,.12,0,.18,0,7.23,0,13.1-5.87,13.1-13.1s-5.86-13.1-13.1-13.1Zm-4.24,35.35c-.78,1.83-1.75,3.67-3.16,5.09-.27,.28-.57,.53-.88,.76-.06,.03-.11,.06-.17,.08-.33,.14-.68,.27-1.02,.38-1.36,.42-2.8,.51-4.22,.35-1.01-.11-1.99-.34-2.96-.63,6.58-.28,10.67-3.55,13.13-7.9-.22,.63-.46,1.26-.72,1.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M391.11,248.9c1.68-.05,3.5-.21,5.06-.9,.9-.4,3.57-1.84,1.99-3-.7-.51-1.47-.79-2.35-.57-1.59,.4-3.09,1.76-3.92,3.11-1.19,1.94-1.52,4.45-1.28,6.68s1.27,4.32,3.11,5.65c2.95,2.12,6.52,1.36,9.28-.64,2.31-1.68,3.54-4.47,4.19-7.17,.51-2.12,.81-4.48,.51-6.66-.51-3.63-3.33-6.92-6.48-8.61-3.66-1.95-7.99-1.81-11.62,.15-1.56,.84-3.04,1.82-4.24,3.14-1.4,1.55-2.36,3.44-2.79,5.49-.87,4.12,.37,8.75,3.48,11.66,.83,.78,1.79,1.39,2.88,1.73,.22,.07,.65-.57,.87-.5-3.77-1.16-6.03-5.36-6.51-9.04-.5-3.79,.7-7.65,3.45-10.35s6.8-3.75,10.53-2.92c3.59,.8,6.74,3.28,8.44,6.53,1.07,2.04,1.32,4.01,1.17,6.26-.17,2.44-.69,4.92-1.77,7.12-.56,1.13-1.28,2.2-2.2,3.06-.23,.21-.46,.41-.71,.59-.12,.09-.59,.36-.25,.19s-.29,.13-.42,.19c-.67,.29-1.38,.48-2.1,.57-1.89,.23-3.81-.38-5.27-1.6-1.59-1.34-2.45-3.26-2.68-5.31-.22-2.02,.04-4.22,.94-6.06,.7-1.43,1.84-3.05,3.54-2.79,.7,.11,1.87,.72,1.78,1.54-.04,.38-.33,.74-.61,.99-.05,.04-.1,.08-.14,.12-.51,.48,.19-.22,.28-.14,0,0-.67,.28-.73,.3-.79,.27-1.62,.43-2.45,.54-.7,.09-1.41,.15-2.12,.17-.3,0-.58,.49-.87,.5h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M382.41,236.52c-.99-1.06-2.36-1.56-3.73-1.93-1.52-.41-3.07-.72-4.63-.89-3.11-.34-6.29-.08-9.21,1.11-.31,.13-.56,.38-.87,.5,2.92-1.2,6.09-1.45,9.21-1.11,1.53,.16,3.05,.46,4.54,.86,1.41,.38,2.81,.87,3.83,1.96,.06,.06,.82-.55,.87-.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M355.56,247.23c2.29,2.59,5.59,3.96,8.96,4.48,3.92,.6,8.06,.31,11.98-.23,.31-.04,.56-.46,.87-.5-3.91,.54-8.06,.84-11.98,.23-3.37-.52-6.66-1.89-8.96-4.48-.05-.06-.83,.54-.87,.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M384.71,264.03c-.56,1.32-1.36,2.52-2.36,3.56-.49,.5-1.02,.96-1.58,1.37-.17,.12-.34,.24-.52,.36-.08,.05-.17,.1-.25,.16,.53-.33,.22-.14,.09-.07-.35,.18-.71,.34-1.08,.48-.31,.12-.56,.38-.87,.5,3.23-1.25,6.06-3.63,7.43-6.85-.03,.08-.36,.2-.44,.25-.09,.05-.39,.16-.43,.25h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M297.82,302.54c-.1,0-.21,0-.32,0-1.33-.08-2.55-.68-3.43-1.68-.87-.98-1.31-2.24-1.24-3.55-.24-.57-2.06-5.02-1.92-7.3l.58-9.37,.66-5.87c.06-.9,.81-1.61,1.72-1.61h.11c.46,.03,.88,.24,1.19,.59,.25,.28,.39,.62,.43,.99l.25-2.24c.06-.9,.81-1.61,1.72-1.61h.11c.46,.03,.88,.24,1.19,.59,.28,.32,.43,.72,.43,1.14l.27-2.85c.06-.9,.81-1.62,1.73-1.62h.11c.95,.06,1.68,.89,1.62,1.84l-.05,1.65,.92-9.32c.05-.75,.68-1.34,1.43-1.34,.88,.05,1.48,.73,1.43,1.52l-.44,16.59,.33,1.75c.08,.41,.12,.83,.13,1.24l.11,5.13c.02,.95-.18,1.92-.57,2.79l-3.57,7.96c-.14,2.54-2.33,4.59-4.95,4.59h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M305.35,261.21s.05,0,.07,0c.65,.04,1.15,.6,1.11,1.26l-.22,8.3-.22,8.3,.33,1.81c.07,.4,.11,.8,.12,1.2l.11,5.13c.02,.92-.17,1.84-.54,2.68l-3.56,7.96c-.16,2.51-2.24,4.45-4.73,4.45-.1,0-.2,0-.3,0-2.61-.16-4.6-2.41-4.44-5.03,0,0-2.07-4.88-1.92-7.25,.15-2.37,.58-9.37,.58-9.37l.66-5.85c.05-.79,.7-1.39,1.48-1.39,.03,0,.06,0,.09,0,.82,.05,1.44,.75,1.39,1.57l.07,3.07s.01,.06,.02,.06c.01,0,.03-.03,.03-.08l.62-5.51c.05-.79,.7-1.39,1.48-1.39,.03,0,.06,0,.09,0,.82,.05,1.44,.75,1.39,1.57l-.06,5.25s0,0,0,0c0,.05,.01,.08,.02,.08,.01,0,.03-.03,.03-.08,0,0,0,0,0,0l.78-8.17c.05-.79,.7-1.39,1.48-1.39,.03,0,.06,0,.09,0,.82,.05,1.44,.75,1.39,1.57l-.24,8.21s0,0,0,0c0,.05,0,.07,.02,.07,.01,0,.02-.03,.03-.07l.74-7.58,.81-8.26c.04-.63,.56-1.11,1.18-1.11m0-.5c-.89,0-1.63,.69-1.68,1.58l-.64,6.55c-.32-.54-.9-.92-1.58-.96-.04,0-.08,0-.12,0-1.04,0-1.91,.82-1.98,1.86l-.16,1.68s-.07-.09-.11-.13c-.35-.4-.83-.63-1.36-.67-.04,0-.08,0-.12,0-1.04,0-1.91,.82-1.98,1.86l-.14,1.22s-.07-.09-.1-.13c-.35-.4-.83-.63-1.36-.67-.04,0-.08,0-.12,0-1.04,0-1.91,.82-1.98,1.86l-.66,5.83-.59,9.4c-.14,2.29,1.6,6.61,1.92,7.36-.05,1.35,.41,2.66,1.31,3.67,.93,1.05,2.21,1.68,3.6,1.76,.11,0,.22,.01,.33,.01,2.73,0,5-2.11,5.22-4.82l3.53-7.88c.41-.9,.61-1.91,.59-2.9l-.11-5.13c0-.43-.05-.86-.13-1.28l-.32-1.76,.22-8.25,.22-8.3c.03-.43-.12-.86-.42-1.2-.3-.34-.71-.54-1.16-.57-.04,0-.07,0-.11,0h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M407.64,349.05c-9.86,1.48-19.8,2.72-19.8,2.72l4.16,12.76s6.99,.27,15.85,.2l-1-2.53c-1.7-4.3-1.38-9.11,.79-13.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M340.81,362.07c-3.78,16.26-13.81,21.88-13.81,49.14,0,25.42,20.15,35.8,45,35.8s43-10.38,43-35.8c0-30.78-10.26-36.1-13.52-49.56-3.83,1.35-14.19,4.36-30.48,4.36s-25.85-2.46-30.19-3.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M424.27,317.81c-3.54-5.37-12.31-18.69-13.94-21.16-.4-.69-.88-1.33-1.43-1.88-.05-.05-.09-.09-.14-.13-.15-.14-.3-.28-.45-.41-.08-.07-.16-.14-.25-.2-.13-.11-.27-.21-.41-.3-.09-.06-.18-.13-.27-.19-.17-.11-.34-.21-.51-.31-.06-.03-.12-.07-.18-.11-.25-.13-.5-.26-.76-.37-.04-.02-.07-.03-.11-.04-.22-.09-.45-.18-.68-.25-.07-.02-.15-.04-.22-.07-.08-.02-.17-.05-.25-.08-3.8-.99-9.52-2.46-14.51-3.55-2.6-.68-4.9-1.29-6.25-1.65-.11-.03-.2-.08-.28-.15-.75-.69-5.06-4.35-12.14-4.35s-11.46,3.73-12.15,4.37c-.07,.07-.15,.12-.24,.15-.94,.38-1.92,.68-2.93,.95-.02,0-.05,.01-.07,.02-5.5,.96-12.63,2.65-16.97,4.21-.15,.05-.29,.12-.43,.19-1.87,.6-3.58,1.79-4.79,3.53,0,0-10.71,15.35-14.77,21.17-1.56,2.24-4.14,5.94-7.01,10.05-.42,.61-1.37,.42-1.51-.31-2.46-12.45-4.84-26.39-5.46-30.04-.08-.49-.57-.79-1.05-.66l-12.47,3.56c-.37,.11-.62,.44-.6,.83,.26,6.42,2.72,58.35,13.98,58.35,9.42,0,24.82-23.54,29.3-30.68,.47-.75,1.6-.56,1.81,.3,.63,2.63,1.29,5.29,1.96,7.88,1.67,6.54,3.93,10.5,4.09,15.47,.12,3.85-.66,7.14-1.35,10.1,4.34,1.47,14.04,3.93,30.19,3.93s26.65-3.01,30.48-4.36c-.68-2.81-1.06-5.96-.98-9.78,.11-4.7,3.8-14.11,6.16-23.77,.21-.85,1.33-1.04,1.81-.31l.17,.25c2.39,3.62,7.19,10.92,11.68,17.75,.33,.49,.04,1.16-.54,1.27-3.46,.66-7.8,1.35-12.14,2.01-2.18,4.05-2.49,8.85-.79,13.15l1,2.53c14.56-.11,34.18-1.13,36.16-5.74,3-7-16.79-36.72-19.73-41.19Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Chair"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 309,
    y: 421,
    width: 124,
    height: 109,
    rx: 30.16,
    ry: 30.16
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginIllustration);
export default __webpack_public_path__ + "static/media/login_illustration.8c38d20266ac44dfa992111c9d42785a.svg";
export { ForwardRef as ReactComponent };